const TRANSLATION = {
  buyModal: {
    afterFree: 'ನಿಮ್ಮ ಮुफ್ತ ಪ್ರಯೋಜನ ನಂತರ',
    btn: 'ಇದನ್ನು ಉಚಿತವಾಗಿ ಪ್ರಯತ್ನಿಸಿ',
    freeTrial: '3-ದಿನದ ಮುಕ್ತ ಪ್ರಯತ್ನ',
    monthLabel: 'ಮಾಸ',
    selectLabel: 'ಪ್ಲಾನ್ ಆಯ್ಕೆಮಾಡಿ',
    title: 'ಸಬ್ಸ್ಕ್ರಿಪ್ಷನ್ ಪ್ಲಾನ್',
    yearLabel: 'ವರ್ಷ',
  },
  contact: {
    block1:
      'ಕಸ್ಟಮೈಸೇಶನ್, ಪ್ರಶ್ನೆಗಳು ಅಥವಾ ಸಲಹೆಗಳಿಗಾಗಿ, ದಯವಿಟ್ಟು contact@noam.tools ನಲ್ಲಿ ನಮ್ಮೊಂದಿಗೆ ಸಂಪರ್ಕಿಸಿ. ನಾವು ತಕ್ಷಣವಾಗಿ ಪ್ರತಿಕ್ರಿಯೆ ನೀಡುತ್ತೇವೆ.',
    block2: 'ಗೂಗಲ್ ಅಪ್ಸ್ ಎಕ್ಸ್ಟೆನ್ಷನ್ ಸ್ಟೋರ್-ನಲ್ಲಿ ★★★★★ ರಿಂದ ರೇಟಿಂಗ್ ನೀಡಿ ಹಾಗೆ ನಮ್ಮನ್ನು ಬೆಂಬಲಿಸಿ.',
    block3: 'ಈ ವಿಸ್ತರಣೆಯನ್ನು ಹಂಚಿಕೊಂಡು ಇತರರಿಗೆ ಸಹಾಯ ಮಾಡಿ:',
    title: 'ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ',
  },
  help: {
    AquickOverviewOfNoam: 'ನೋಮ್ ನှင့် ಸಂಬಂಧಿಸಿದ ತ್ವರಿತ ಅವಲೋಕನ',
    ChatPDF: 'ಚ್ಯಾಟ್ ಪಿಡಿಎಫ್',
    ChatPDF2: 'ಚ್ಯಾಟ್‌ಪಿಡಿಎಫ್',
    FavoritesManagement: 'ಪ್ರಿಯತಮ ವ್ಯವಸ್ಥಾಪನೆ',
    Fixedplugin: 'ಫಿಕ್ಸ್ಡ್ ಪ್ಲಗಿನ್',
    Focusing: 'ಕೇಂದ್ರೀಕರಿಸುವುದು',
    Free: 'ವಿಶೇಷವಾಗಿ ಹಣವಿಲ್ಲದ',
    FreeTrialBenefits: 'ಫ್ರೀ ಟ್ರಯಲ್ ಲಾಭಗಳು',
    GoWithWikipedia: 'ವಿಕಿಪೀಡಿಯಾವನ್ನು ಬಳಸಿ',
    GoWithYouTube: 'ಯುಟ್ಯೂಬ್ ಗೆ ಹೋಗಿ',
    HoverTranslation: 'ಹೋವರ್ ಅನುವಾದ',
    Howtouse: 'ಇದನ್ನು ಹೇಗೆ ಬಳಸುವುದು',
    ImageTranslation: 'ಇಮೇಜ್ ಅನುವಾದ',
    InstantTranslation: 'ತಕ್ಷಣ ಅನುವಾದ',
    Membership: 'ಸದಸ್ಯತ್ವ',
    NoamHelp: 'ನೋಮ್ ನಿಮಗೆ ಅನುವಾದ ಮತ್ತು ಸಾರಾಂಶ ಮಾಡಲು ಸಹಾಯ ಮಾಡುತ್ತದೆ',
    PDFparallelTranslation: 'PDFParallelGroupಿ ಅನುವಾದ',
    ParallelTranslation: 'ParallelGrouplyphic Translation',
    SkipAllSteps: 'ಎಲ್ಲಾ ಹಂತಗಳನ್ನು ತಪ್ಪಿಸಿ',
    Summary: 'ಸಾರಾಂಶ',
    Translation: 'ಭಾಷಾಂತರ',
    TryItForFree: 'ಕೊನೆಗೆ ಉಚಿತವಾಗಿ ಪ್ರಯತ್ನಿಸಿ',
    Video: 'ವೀಡಿಯೋ',
    VideoSummary: 'ವೀಡಿಯೋ ಸಾರಾಂಶ',
    VideoTranslation: 'ವೀಡಿಯೊ ಅನುವಾದ',
    WebSummary: 'ವೆಬ್ ಸಾರಾಂಶ',
    WordSelectionTranslation: 'ಶಬ್ದ ಆಯ್ಕೆ ಅನುವಾದ',
    benefits: 'ನಿಮ್ಮ ಕಡೆಗೆ ಲಾಭಗಳು ಕಾಯುತ್ತಿವೆ!',
    dayFree: '3-ದಿನಗಳ ಮುಕ್ತ ಪ್ರಯೋಜನೆ',
    done: 'ಮಾಡಿದ',
    next: 'ಮುಂದಿನ',
    pin: 'ಸುಲಭ ಪ್ರವೇಶಕ್ಕಾಗಿ ನೋಮ್ ಅನ್ನು ಪಿನ್ ಮಾಡಿ～～',
    planIsNotExist: 'ಪ್ಲಾನ್ ಲಭ್ಯವಿಲ್ಲ',
    startWiki: 'ವಿಕಿಮೀಡಿಯಾವನ್ನು ಹೊಂದಿ ಪ್ರಾರಂಭಿಸೋಣ!',
    startYoutube: 'ಯೂಟ್ಯೂಬ್ ನೊಂದಿಗೆ ಪ್ರಾರಂಭಿಸೋಣ!',
    try: 'ಇದನ್ನು ಪ್ರಯತ್ನಿಸಿ',
    tryNow: 'ಈಗ ಇದನ್ನು ಪ್ರಯತ್ನಿಸಿ!',
  },
  home: {
    PDFTranslate: {
      desc: 'ಬೈಲಿಂಗ್ವಲ್ ಅನುವಾದ + ಚ್ಯಾಟ್ ಪಿಡಿಎಫ್',
      sub1: {
        desc: 'ದ್ವಿಭಾಷಾ ಓದುವಿಕೆಯು ನಿಮಗೆ ಮೂಲ ಪಠ್ಯ ಮತ್ತು ಅನುವಾದವನ್ನು ಪಕ್ಷದೊಂದಿಗೆ ಹೋಲಿಸುವ ಅವಕಾಶವನ್ನು ನೀಡುತ್ತದೆ, ಓದುವ ಕಾರ್ಯಕ್ಷಮತೆಯನ್ನು ಸುಧಾರಿಸುತ್ತದೆ.',
        title: 'ಇಬ್ರೆಭಾಷಾ ಓದುವಿಕೆ',
      },
      sub2: {
        desc: 'AI ಪಠ್ಯವನ್ನು ವಿಶ್ಲೇಷಿಸುತ್ತದೆ ಮತ್ತು ಸಾರಾಂಶಿಸುತ್ತದೆ, ಮತ್ತು PDF ವಿಷಯದ ಆಧಾರದ ಮೇಲೆ ನಿಮ್ಮ ಪ್ರಶ್ನೆಗಳಿಗೆ ಉತ್ತರಿಸುತ್ತದೆ.',
        title: 'ಚ್ಯಾಟ್ ಪಿಡಿಎಫ್',
      },
      sub3: {
        desc: 'ಉನ್ನತ ಸಂಶೋಧನೆ ಮತ್ತು ಕಾರ್ಯನಿರ್ವಹಣೆಗಾಗಿ AI-ಶಕ್ತಿ ಪ್ರದರ್ಶಿಸುವ PDF ಅನುವಾದ.',
        title: 'ಶ್ರೇಷ್ಠತೆ ಮತ್ತು ಸಾಮರ್ಥ್ಯ',
      },
      title: 'PDF ಅನ್ನು ಅನುವಾದಿಸಿ',
    },
    aiAssistant: {
      desc: 'ವೆಬ್ ಅನುವಾದವನ್ನು ಪ್ರಜ್ಞತರ ಮತ್ತು ಸುಲಭಗೊಳಿಸುವುದು',
      panel1: {
        desc: 'ದ್ವಿಭಾಷಾ ಕ್ರಾಸ್-ರೆಫರೆನ್ಸಿಂಗ್ ಅನುವಾದಗಳು ಮೂಲ ಪಠ್ಯವನ್ನು ಅನುವಾದದೊಂದಿಗೆ ಹೋಲಿಸುವುದಕ್ಕೆ ಸಹಾಯ ಮಾಡುತ್ತವೆ, ಇದರಿಂದ ನೀವು უკಷ್ಟად ಅರ್ಥಮಾಡಿಕೊಳ್ಳಬಹುದು ಮತ್ತು ನಿಮ್ಮ ಓದುವಿಕೆ ಸಕ್ರಿಯತೆಯನ್ನು ಸುಧಾರಿಸಬಹುದು. ',
        title: 'ದ್ವಿಭಾಷಾ ಅನುವಾದ',
      },
      panel2: {
        left: {
          desc: 'ವೆಬ್ ಪೇಜ್ ಅನ್ನು ಬ್ರೌಸ್ ಮಾಡುವಾಗ, ಅನುವಾದವನ್ನು ನೋಡಲು ನೀವು ಅನುವಾದಿಸಬೇಕಾದ ವಿಷಯದ ಮೇಲೆ ಹೋವರ್ ಮಾಡಿ.',
          title: 'ಹೋವರ್ ಅನುವಾದ',
        },
        right: {
          desc: 'ವೆಬ್ ಪೇಜ್ ಅನ್ನು ಬ್ರೌಸ್ ಮಾಡುವಾಗ, ಅನುವಾದವನ್ನು ನೋಡಲು ನೀವು ಅನುವಾದಿಸಲು ಬಯಸುವ ಪಠ್ಯವನ್ನು ಆಯ್ಕೆ ಮಾಡಿ.',
          title: 'ಪಠ್ಯ ಆಯ್ಕೆ ಅನುವಾದ',
        },
      },
      panel3: {
        one: {
          desc: 'ಯಾವುದೇ ಸಮಯದಲ್ಲಿ, ಎಲ್ಲಿಯೇ ವೆಬ್ ಪುಟಗಳು ಮತ್ತು ವೀಡಿಯೋ ವಿಷಯವನ್ನು ಅನುವಾದಿಸಿ ಮತ್ತು ಸಾರಾಂಶಿಸಿ၊ ಸುಗಮ ಅನುಭವ ਲਈ!',
          title: 'ಪಾಯಿಂಟ್ ಆಂಡ್ ಕ್ಲಿಕ್',
        },
        three: {
          desc: 'AI-ನಡಿತ ಹೆಚ್ಚಿನ ಭಾಷಾ ಮಾದರಿ ಅನುವಾದದ ತಕ್ಷಣತೆ ಮತ್ತು ಸ್ಥಿರತೆಯನ್ನು ಧರಿಸಿಕೊಂಡು ಸುಧಾರಿತ ಓದುವ ಅನುಭವವನ್ನು ಒದಗಿಸುತ್ತದೆ.',
          title: 'AI-ನಿರ್ದೇಶಿತ',
        },
        two: {
          desc: 'ಬಹು-ಭಾಷಾ ಪೂರ್ಣ ಕವರೇಜ್, ದ್ವಿಭಾಷಾ ಅಡೆತಡವಿಲ್ಲದ ಓದುವಿಕೆ, ಒಂದು ಕ್ಲಿಕ್ ಅನ್ನು ಮಾಡಿ ಅನುವಾದ - ವ್ಯತ್ಯಾಸವನ್ನು ಅನುಭವಿಸಿ!',
          title: 'ಇನ್ನಷ್ಟು ವಿಶೇಷವಾಗಿ ವಿಶೇಷವಾಗಿ ಮತ್ತು ಸುಲಭ',
        },
      },
      panel4: {
        tab1: {
          desc: 'ನಿಮ್ಮ ಸಾಮರ್ಥ್ಯ ತಜ್ಞ - ChatGPT ಅನ್ನು ಬಳಸಿ ನೋಯಮ್ YouTube ವೀಡಿಯೊ ವಿಷಯವನ್ನು ಅನುವಾದಿಸುತ್ತಾರೆ ಮತ್ತು ಸಾರಾಂಶಿಸುತ್ತಾರೆ ताकि ನಿಮ್ಮ ಸಮಯವನ್ನು ಉಳಿಸುತ್ತಾರೆ!',
          key: 'ವೀಡಿಯೋ',
          title: 'ವೀಡಿಯೋ ಅನುವಾದ ಮತ್ತು ಸಾರಾಂಶ',
        },
        tab2: {
          desc: 'ವೆಬ್ ಅನ್ನು ಬ್ರೌಸ್ ಮಾಡುವಾಗಿ ಚಿತ್ರಗಳನ್ನು ಅನುವಾದಿಸಲು ಕ್ಲಿಕ್ ಮಾಡಿ.',
          key: 'ಛಾಯಾಚಿತ್ರ',
          title: 'ಇಮೇಜ್ ಅನುವಾದ',
        },
        tab3: {
          desc: 'ವೆಬ್ ಪೇಜಿನಿಂದ ಪ್ರಮುಖ ಮಾಹಿತಿಯನ್ನು ತಕ್ಷಣವಾಗಿ ಹೇಗ್ಗುತ್ತದೆ ಮತ್ತು ಸಾರಾಂಶವನ್ನು ಒದಗಿಸುತ್ತದೆ, ನಿಮ್ಮ ಓದುವ ಸಾಮರ್ಥ್ಯವನ್ನು ಹೆಚ್ಚಿಸುತ್ತದೆ.',
          key: 'ವೆಬ್',
          title: 'ವೆಬ್ ಅನುವಾದ ಮತ್ತು ಸಾರಾಂಶ',
        },
        tag1: 'ಸಾಮಾನ್ಯ',
        tag2: 'ಕಾರ್ಯಕ್ಷಮ',
        tag3: 'ಊದುವುದು ಸುಲಭ',
      },
      title: 'AI ಸಹಾಯಕ',
    },
    getStart: 'ಆರಂಭಿಸಿ',
    getStartedForFree: 'ವಿಶೇಷವಾಗಿ ಶುರು ಮಾಡಿ',
    howItWork: {
      desc: 'ನೋಮ್ AI ಮಾಡೆಲ್‌ಗಳನ್ನು ஒருங்கிணைக്കുന്നു ಮತ್ತು ಬಳಕೆದಾರರಿಗೆ ಕ್ರಾಸ್-ಭಾಷಾ ವೆಬ್ ಪೇಜ್ ಅನುವಾದ ಮತ್ತು ಸಾರಾಂಶ, PDF ಮತ್ತು ಚಿತ್ರ ಅನುವಾದ, ವೀಡಿಯೊ ಅನುವಾದ ಮತ್ತು ಸಾರಾಂಶಕ್ಕೆ ಬುದ್ಧಿಮತ್ತನಾದ ಅನುಭವವನ್ನು ಒದಗಿಸುತ್ತದೆ',
      title: 'ಇದು ಹೇಗೆ ಕಾರ್ಯನಿರ್ವಹಿಸುತ್ತದೆ',
    },
    lastBlock: { desc: 'ಒಂದು ಸುಲಭವಾದ ಓದುವ ಅನುಭವಕ್ಕೆ ಉತ್ತಮ AI ಅನುವಾದ' },
    top: {
      desc: 'ನೋಮ್ ಒಂದು ಮುಕ್ತ AI ಬ್ರೌಸರ್ ವಿಸ್ತರಣೆಯಾಗಿದ್ದು ಅದು ವೆಬ್ ಪುಟಗಳು, ವೀಡಿಯೊಗಳು ಮತ್ತು PDF ವಿಷಯವನ್ನು ಅನುವಾದಿಸಿ ಮತ್ತು ಸಾರಾಂಶಿಸುವುದನ್ನು ಸಹಾಯಿಸುತ್ತದೆ.\n      ನೋಮ್ ಗೆ ಸೇರಿ ಮತ್ತು ಮ್ಯಾಜಿಕ್ ಅನ್ನು ಅನುಭವಿಸಿ!',
      title1: 'ಒಂದು ಮ್ಯಾಜಿಕ್',
      title2: 'ಒಂದು ಕ್ಲಿಕ್',
    },
    userReviews: {
      desc: 'ಕ್ರೋಮ್ ವೆಬ್ ಸ್ಟೋರ್ ಮೇಲಿನ ಐದು-ಸ್ಟಾರ್ реವ್ಯೂಗಳು',
      title: 'ಯೋಜನೆ ವಿಮರ್ಶೆಗಳು',
    },
  },
  installTips: {
    btn: 'ಈಗ ಪ್ರಯತ್ನಿಸಿ',
    text: 'ಇನ್ನಷ್ಟು ವಿಶೇಷತೆಗಳನ್ನು ಅನ್ಲಾಕ್ ಮಾಡಲು "ನೋಮ್ ಬ್ರೌಸರ್ ಪ್ಲಗಿನ್" ಅನ್ನು ಇನ್ಸ್ಟಾಲ್ ಮಾಡಿ! ವೆಬ್ ಕ್ರಾಸ್-ರಿಫರೆನ್ಸಿಂಗ್, ವೆಬ್ ವೀಡಿಯೊ ಸಮಾರಿSesನ್ ಮತ್ತು ಇನ್ನಷ್ಟು!',
  },
  locale: {
    af: 'ಅಫ್ರಿಕಾನ್ಸ್',
    am: 'ಅಮ್ಹಾರಿಕ್',
    ar: 'ಅರಬಿ',
    as: 'ಅಸ್ಸಾಮೀ',
    auto: 'ಆಟೋ ಪತ್ತೆ ಮಾಡಿ',
    az: 'ಅಜೆರ್ಬೈಜಾನಿ',
    ba: 'ಬಾಶ್ಕಿರ್',
    bg: 'ಬಲ್ಗೇರಿಯನ್',
    bn: 'ಬಂಗ್ಲ',
    bo: 'ತಿಬೇಟ್',
    bs: 'ಬೋಸ್ನಿಯನ್',
    ca: 'ಕ್ಯಾಟಲಾನ್',
    cs: 'चेक',
    cy: 'ವೆಲ್ಷ್',
    da: 'ಡೇನಿಷ್',
    de: 'ಜರ್ಮನ್',
    dsb: 'ಲೋವರ್ ಸಾರ್ಬಿಯನ್',
    dv: 'ಡಿವೆಹಿ',
    el: 'ಗ್ರೀಕ್',
    en: 'ಇಂಗ್ಲಿಷ್',
    es: 'ಸ್ಪ್ಯಾನಿಷ್',
    et: 'ಎಸ್ಟೋನಿಯನ್',
    eu: 'ಬಾಸ್ಕ್',
    fa: 'ಪಾರ್ಸಿ',
    fi: 'ಫಿನ್ನಿಶ್',
    fil: 'ಫಿಲಿಪಿನ',
    fj: 'ಫಿಜಿಯನ್',
    fr: 'ಫ್ರೆಂಚ್',
    frCA: 'ಫ್ರೆಂಚ್ (ಕೆನಡಾ)',
    ga: 'ಐರಿಷ್',
    gl: 'ಗ್ಯಾಲಿಶಿಯನ್',
    gom: 'ಕೊಂಕಣಿ',
    gu: 'ಗುಜರಾತಿ',
    ha: 'ಹೌಸಾ',
    he: 'ಹೀಬ್ರು',
    hi: 'ಹಿಂದಿ',
    hr: 'ಕ್ರೋಷಿಯಾ',
    hsb: 'ಉಪ್ಪರ್ ಸಾರ್ಬಿಯನ್',
    ht: 'ಹೈಟಿಯನ್ ಕ್ರಿಯೋಲ್',
    hu: 'ಹಂಗೇರಿಯನ್',
    hy: 'ಅರ್ಮೇನಿಯನ್',
    id: 'ಇಂಡೋನೇಷಿಯನ್',
    ig: 'ಇಗ್ಬೊ',
    ikt: 'ಇನುಯಿನ್ನಕ್ಟುನ್',
    is: 'ಐसल್ಯಾಂಡಿಕ್',
    it: 'ಇಟಾಲಿಯನ್',
    iu: 'ಇನುಕ್ಟಿಟುಟ್',
    iuLatn: 'ಇನುಕ್ಟಿಟುಟ್ (ಲ್ಯಾಟಿನ್)',
    ja: 'ಜಪಾನೀಸ್',
    ka: 'ಜಾರ್ಜಿಯನ್',
    kk: 'ಕಜಕ್',
    km: 'ಖ್ಮೇರ್',
    kmr: 'ಕುರ್ದಿಷ್ (ಉತ್ತರ)',
    kn: 'ಕನ್ನಡ',
    ko: 'ಕೊರಿಯාන್',
    ku: 'ಕುರ್ದಿಶ್ (ಮಧ್ಯ)',
    ky: 'ಕಿರ್ಗಿಜ್',
    ln: 'ಲಿಂಗಾಲ',
    lo: 'ಲಾವ್',
    lt: 'ಲಿಥುವೇನಿಯನ್',
    lug: 'ಗಾಂಡ',
    lv: 'ಲ್ಯಾಟ್ವಿಯನ್',
    lzh: 'ಚೀನೀ (ಸಾಹಿತ್ಯದ)',
    mai: 'ಮೈತಿಳಿ',
    mg: 'ಮಲಗಾಸಿ',
    mi: 'ಮাওರಿ',
    mk: 'ಮೆಸೇಡೋನಿಯನ್',
    ml: 'ಮಲಯാളം',
    mnCyrl: 'ಮೊಂಗೋಲಿ (ಸಿರಿಲಿಕ್)',
    mnMong: 'ಮಂಗೋಲಿಯನ್ (ಪ್ರಾಚೀನ)',
    mr: 'ಮರಾಠಿ',
    ms: 'ಮಲಯ',
    mt: 'ಮಾಲ್ಟೀಸ್',
    mww: 'ಹ್ಮೊಂಗ್ ಡಾ',
    my: 'ಮ್ಯಾನ್ಮಾರ್ (ಬರ್ಮೀಸ್)',
    nb: 'ನಾರ್ವೇಜಿಯನ್',
    ne: 'ನೆಪಾಳಿ',
    nl: 'ಡಚ್',
    noSearchLang: 'ಭಾಷೆಯನ್ನು ಬೆಂಬಲಿಸಲಾಗುವುದಿಲ್ಲ',
    nso: 'ಸೆಸೋತೋ ಸಾ ಲೆಬೋಯಾ',
    nya: 'ನ್ಯಾನ್ಜಾ',
    or: 'ಓಡಿಯ',
    otq: 'ಕ್ವೆರೆಟಾರೋ ಒಟೋಮಿ',
    pa: 'ಪಂಜਾਬಿ',
    pl: 'ಪೋಲಿಶ್',
    placeholder: 'ಸರ್ಚ್',
    prs: 'ದರಿ',
    ps: 'ಪಶ್ತೋ',
    pt: 'ಪೋರ್ಚುಗೀಸ್ (ಬ್ರಜಿಲ್)',
    ptPT: 'ಪೋರ್ಚುಗೀಸ್ (ಪೋರ್ಚುಗಲ್)',
    ro: 'ರೋಮೇನಿಯನ್',
    ru: 'ರಷ್ಯನ್',
    run: 'ರುಂಡಿ',
    rw: 'ಕಿನ್ಯಾರ್ವಾಂಡಾ',
    sd: 'ಸಿಂಧಿ',
    si: 'ಸಿಂಹಳ',
    sk: 'ಸ್ಲೋವಾಕ್',
    sl: 'ಸ್ಲೋವೇನಿಯನ್',
    sm: 'ಸಾಮೋವಾನ್',
    sn: 'ಶೋನಾ',
    so: 'ಸೋಮಾಲಿ',
    sq: 'ಅಲ್ಬೇನಿಯನ್',
    srCyrl: 'ಸೆರ್ಬಿಯನ್ (ಸಿರಿಲಿಕ್)',
    srLatn: 'ಸರ್ಬಿಯಾನ್ (ಲ್ಯಾಟಿನ್)',
    st: 'ಸೆಸೋಥೊ',
    sv: 'ಸ್ವೀಡಿಷ್',
    sw: 'ಸ್ವಾಹಿಲಿ',
    ta: 'ತಮಿಳ',
    te: 'ತೆಲುಗು',
    th: 'ತೈ',
    ti: 'ಟಿಗ್ರಿನ್ಯ',
    tk: 'ತುರ್ಕ್ಮೇನ್',
    tlhLatn: 'ಕ್ಲಿಂಗನ್',
    tlhPiqd: 'ಕ್ಲಿಂಗನ್ (pIqaD)',
    tn: 'ಸೆಟ್ಸ්වಾನಾ',
    to: 'ಟೊಂಗನ್',
    tr: 'ತರ್ಕಿಶ್',
    tt: 'ತಾತಾರ್',
    ty: 'ತಾಹಿತಿಯನ್',
    ug: 'ಯುಘುರ್',
    uk: 'ಯುಕ್ರೇನಿಯನ್',
    ur: 'ಉರ್ದು',
    uz: 'ಉಜ್ಬೇಕ್ (ಲ್ಯಾಟಿನ್)',
    vi: 'ವಿಯೆಟ್ನಾಮೀ',
    xh: 'ಝೋಸಾ',
    yo: 'ಯೊರುಬಾ',
    yua: 'ಯುಕಾಟೆಕ್ ಮಾಯಾ',
    yue: 'ಕ್ಯಾಂಟೋನೀಸ್ (ಪ್ರಾಚೀನ)',
    zh: 'ಚೀನೀ',
    zhHans: 'ಚೀನೀ ಸಂಯೋಜಿತ',
    zhHant: 'ಚೈನೀಸ್ ಪ್ರಾಚೀನ',
    zu: 'ಜುಲು',
  },
  login: {
    and: 'ಮತ್ತು',
    btn: 'ಗೂಗಲ್ದೊಂದಿಗೆ ಲಾಗ್ ಇನ್',
    btn1: 'ಈಗ ಲಾಗಿನ್ ಮಾಡಿ',
    desc: 'ಇನ್ನಷ್ಟು ಅನುಭವಗಳನ್ನು ಅನ್ಲಾಕ್ ಮಾಡಲು ಲಾಗ್ ಇನ್ ಮಾಡಿ',
    policy: 'ಪ್ರೈವೇಸಿ ನಿಯಮಗಳು',
    terms: 'ಬಳಕার ನಿಯಮಗಳು',
    tips: 'ಸೈನ್ ಅಪ್ ಮಾಡುವ ಮೂಲಕ, ನಾನು ಒಪ್ಪುತ್ತೇನೆ',
    title: 'ನೋಮ್ಗೆ ಸ್ವಾಗತಿಸುತ್ತೇವೆ',
  },
  pageFooter: {
    follow: { facebook: 'ಫೇಸ்பುಕ್', title: 'ಅನುಸರಿಸಿ', twitter: 'ಟ್ವಿಟರ್' },
    legal: { policy: 'ಗೌಪ್ಯತೆ ನಿಯಮಾವಧಿ', terms: 'ಸೇವಾ ಸ Geschäfts', title: 'ಕಾನೂನಿ' },
    product: {
      image: 'ಇಮೇಜ್ ಅನುವಾದ',
      pdf: 'PDF ಅನುವಾದ',
      title: 'ತಯಾರಗಳು',
      video: 'ವೀಡಿಯೋ ಅನುವಾದ ಮತ್ತು ಸಾರಾಂಶ',
      web: 'ವೆಬ್ ಅನುವಾದ ಮತ್ತು ಸಾರಾಂಶ',
    },
    resources: { title: 'ಸಂಪನ್ಮೂಲಗಳು' },
    tools: { title: 'ಉಪಕರಣಗಳು', pdf: 'PDF ಅನುವಾದ' },
  },
  pageHeader: {
    contact: 'ಸಂಪರ್ಕ',
    help: 'ಸಹಾಯ',
    logout: 'ಲಾಗ್ ಔಟ್',
    logoutSucc: 'ಲಾಗ್ ಔಟ್ ಮಾಡಲಾಗಿದೆ.',
    pricing: 'ಬೆಲೆ ನಿಯೋಜನೆ',
    settings: 'ಸೆಟ್ಟಿಂಗ್ಗಳು',
    signUp: 'ಲಾಗಿನ್ ಮಾಡಿ',
  },
  pdf: {
    autoDetect: 'ಆಟೋ-ಪತ್ತೆ',
    cancelBtn: 'ರದ್ದು ಮಾಡಿ',
    cancelUpload: 'ರದ್ದು ಮಾಡಿ',
    chatPdf: {
      summaryError: 'ಸಾರಾಂಶ ವಿಫಲವಾಗಿದೆ, ನಂತರ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ',
      chatError: 'ಚ್ಯಾಟ್ ವಿಫಲವಾಗಿದೆ, ದಯವಿಟ್ಟು ನಂತರ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ',
      Search: 'ಶೋಧಿ',
      cancel: 'ರದ್ದು ಮಾಡಿ',
      chatTitle: 'ನೋಮ್‌ಗೆ ಸ್ವಾಗತം! ನಿಮ್ಮ PDF ನ ಸಾರಾಂಶ ಇಲ್ಲಿದೆ:',
      clear: 'ನಿಶ್ಚಿತ',
      clearContent:
        'ಇದು ಹೊಸ ಸಂಭಾಷಣೆಯನ್ನು ಪ್ರಾರಂಭಿಸುತ್ತದೆ. ಪ್ರಸ್ತುತ ಸಂಭಾಷಣೆಯನ್ನು ಸಂರಕ್ಷಿಸಲಾಗುವುದಿಲ್ಲ. ನೀವು ಖಚಿತವಾಗಿದ್ದೀರಾ?',
      clearDialogTitle: 'ದಯವಿಟ್ಟು ದೃಢಪಡಿಸಿ',
      clearSucc: 'ಶುದ್ಧീകരിച്ച',
      copy: 'ಕಾಪಿ',
      copySucc: 'ಕಾಪಿ ಮಾಡಲಾಗಿದೆ',
      delete: 'ಅಳಿಸಿ',
      deleteCancel: 'ರದ್ದು ಮಾಡಿ',
      deleteContent: 'ಈ PDF ಅನ್ನು ಅಳಿಸಿದ ನಂತರ ಪುನರುಸ್ಥಾಪಿಸಲಾಗುವುದಿಲ್ಲ. ನೀವು ಖಚಿತವಾಗಿ ಮಾಡುತ್ತೀರಾ?',
      deleteOk: 'ಅಳಿಸಿ',
      deleteSuccess: 'ಅಳಿಸಲಾಗಿದೆ',
      deleteTitle: 'ಅಳಿಸುವುದನ್ನು ದೃಢಪಡಿಸಿ',
      expand: 'ಅಡಿಯುವುದು',
      historyTitle: 'ಇತಿಹಾಸ',
      listError:
        'ರೀಡಿಂಗ್ ಲಿಸ್ಟ್ ಲೋಡ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ. ನಂತರ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ ಅಥವಾ ಸಪೋರ್ಟ್ ಗೆ ಸಂಪರ್ಕಿಸಿ.',
      loading: 'ಲೋಡ್ ಮಾಡುತ್ತಿದೆ...',
      noDataDesc: 'ಇನ್ನು ಇತಿಹಾಸ ಇಲ್ಲ.',
      noMore: 'ಇನ್ನಷ್ಟು ವಿಷಯವಿಲ್ಲ.',
      placeholder: 'ಈ ಪಿಡಿಎಫ್ ಬಗ್ಗೆ ಯಾವುದನ್ನಾದರೂ ಕೇಳಿ',
      summaryTitle: 'ನೀವು ಈ ಪ್ರಶ್ನೆಗಳಲ್ಲಿ ಆಸಕ್ತಿ ಹೊಂದಬಹುದು:',
    },
    collectionEmpty: 'ನಿಮ್ಮ ಸಂಗ್ರಹය ಖಾಲಿ છੈ।',
    collectionTab: 'ನೋಟ್ಗಳು',
    dataLoading: 'ಲೋಡ್ ಮಾಡುತ್ತಿದೆ...',
    dialogContent: 'ಇದನ್ನು ಅಳಿಸಲು ನೀವು ಖಚಿತವಾಗಿ ಬಯಸುತ್ತೀರಾ?',
    dialogTitle: 'ದಯವಿಟ್ಟು ದೃಢೀಕರಿಸಿ',
    download: {
      both: 'ದ್ವಿಭಾಷಿ',
      btn: 'ಉಳಿಸಿ',
      cancel:
        'ಈ ವಿಂಡೋವನ್ನು ಮುಚ್ಚುವುದು PDF ಡೌನ್ಲೋಡ್ ಅನ್ನು ರದ್ದು ಮಾಡುತ್ತದೆ. ನೀವು ರದ್ದು ಮಾಡಲು ನಿಶ्चಿತವೇ?',
      desc: 'ಡೆವೈಸ್ ಗೆ ಸೇವ್ ಮಾಡಿ: ಅನುವಾದಗಳನ್ನು ಚಿತ್ರಗಳಾಗಿ ಡೌನ್ಲೋಡ್ ಮಾಡುತ್ತದೆ; ಸೇವ್ ಮಾಡಿ & ಪ್ರಿಂಟ್ ಮಾಡಿ: ಮೂಲ ಸ್ವರೂಪದಲ್ಲಿ ಅನುವಾದಗಳನ್ನು ಡೌನ್ಲೋಡ್ ಮಾಡುತ್ತದೆ, ಕಾಪಿ ಸಪೋರ್ಟ್ ಹೊಂದಿದೆ.',
      download: 'ಡೌನ್ಲೋಡ್',
      downloadMsg1: 'PDF ಅನುವಾದ ಪ್ರಗತಿ:',
      downloadMsg2: 'ಅನುಮಾನಿತ ಉಳಿದ ಸಮಯ:',
      downloadSucc: 'PDF ಸಿದ್ಧವಾಗಿದೆ! ಸೇವ್ ಮಾಡಲು ಕ್ಲಿಕ್ ಮಾಡಿ.',
      downloadTip: 'PDF ಡೌನ್ಲೋಡ್ ಆಗುತ್ತಿದೆ. ಡೌನ್ಲೋಡ್ ದೋಷಗಳನ್ನು ತಪ್ಪಿಸಲು ಈ ವಿಂಡೋವನ್ನು ಮುಚ್ಚಬೇಡಿ.',
      error: 'ಸೇವ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ. ಬದಲಿಗೆ ಪ್ರಿಂಟ್ ಮಾಡುವ ಪ್ರಯತ್ನಿಸಿ.',
      fileName: 'ಫೈಲ್ ಹೆಸರು:',
      fileType: 'ಫೈಲ್ ಪ್ರಕಾರ:',
      loading: 'ಉಳಿಸುತ್ತಿದೆ...',
      loading2: 'ಲೋಡ್ ಮಾಡುತ್ತಿದೆ...',
      minute: 'ನಿಮಿಷಗಳು...',
      msg1: 'ಈ ದಸ್ತಾವೇಜಿನಲ್ಲಿ ಕೆಲವು ಅನುವಾದಗಳು ಮೂಲ ಪಠ್ಯಕ್ಕಿಂತ ಉದ್ದವಾಗಿವೆ, ಮತ್ತು ಡೌನ್ಲೋಡ್ ಮಾಡಿದ ಫೈಲಿನಲ್ಲಿ ಅವು ಅಧಿಪತ್ಯ ಹೊಂದಬಹುದು. ವೆಬ್ಪೇಜಿನಲ್ಲಿ ಓದುವ 것을 ನಾವು ಶ್ರೇಷ್ಠ ಸಲಹೆ ಮಾಡುತ್ತೇವೆ.',
      msg2: 'ಭಾಷಾಂತರisierung ಇನ್ನು ಪೂರ್ಣವಾಗಿಲ್ಲ. ಭಾಷಾಂತರisierung ಪೂರ್ಣವಾದ ನಂತರ ಡೌನ್ಲೋಡ್ ಮಾಡಿ.',
      msg3: '2. ಕೆಲವು ಅನುವಾದಗಳು ತುಂಬಾ ಉದ್ದವಾಗಿರುತ್ತವೆ. ಪಠ್ಯದ ಅತಿ ವಿಶಾಲತೆಯನ್ನು ತಪ್ಪಿಸಿಕೊಳ್ಳಲು ವೆಬ್ಪೇಜಿನಲ್ಲಿ ಓದಿ.',
      msg4: 'ಭಾಷಾಂತ್ರ ಕಾರ್ಯಗಳು მიმತ್ತಿದೆ. ಅವುಗಳು ಪೂರ್ಣವಾದ ನಂತರ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
      progress:
        'PDF ಅನ್ನು ಅನುವಾದಿಸುತ್ತಿದೆ. ಪ್ರಗ್ರೆಸ್: {{progress}}, ಅಪেক್ಷಿತ ಉಳಿದ ಸಮಯ: {{minutes}} ನಿಮಿಷಗಳು...',
      save: 'ಸಾಧನೆಗೆ ಉಳಿಸಿ',
      savePrint: 'ಸೇವ್ ಮಾಡಿ & ಮುದ್ರಿಸಿ',
      success: 'ಡೌನ್ಲೋಡ್ ಮಾಡಲಾಗಿದೆ',
      trans: 'ಕನ್ನಡಕ್ಕೆ ಅನುವಾದ ಮಾತ್ರ',
      transContinue: 'ಭಾಷಾಂತ್ರವನ್ನು ಮುಂದುವರಿಸಿ',
    },
    downloadBtn: 'ಡೌನ್ಲೋಡ್',
    dragTipModal: {
      black: 'ಶ್ರೇಣಿ',
      leftKey: 'ಎಡ ಬಟನ್',
      ok: 'ಇದನ್ನು ತಿಳಿದಿದೆ',
      press: 'ಪ್ರೆಸ್',
      tips: 'ಇಳಿಸಿ ವೀಕ್ಷಿಸಲು',
    },
    entry: 'PDFಗಳು',
    fileErrMsg: 'ಫೈಲ್ ಓದುವಿಕೆ ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ನಂತರ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ ಅಥವಾ ಸಪೋರ್ಟ್ಗೆ ಸಂಪರ್ಕಿಸಿ.',
    fileMsg: 'ಪ್ರಸ್ತುತ ಕಡತ ಗಾತ್ರ:',
    fileMsg2: 'ದಯವಿಟ್ಟು 300MB કરતાં ಚಿಕ್ಕ ಫೈಲ್ ಅಪ್ಲೋಡ್ ಮಾಡಿ.',
    freeBannerBtn: 'ಅಪ್ಗ್ರೇಡ್',
    freeBannerTips: 'ಫ್ರೀ PDF ಅನುವಾದದ ಮಿತಿ ತಕ್ಷಣಿಸಿದೆ',
    guide: {
      placeholder: 'PDF ಲಿಂಕ್ ಅನ್ನು ಇಲ್ಲಿ ಪೇಸ್ಟ್ ಮಾಡಿ',
      start: 'ಭಾಷಾಂತ್ರಣವನ್ನು ಪ್ರಾರಂಭಿಸಿ',
      text1: 'ದ್ವಿಭಾಷಾ ಓದುವಿಕೆ',
      text2:
        'ಮೂಲ ಪಠ್ಯ ಮತ್ತು ಅನುವಾದವನ್ನು ಪಕ್ಷಪಕ್ಷವಾಗಿ ಹೋಲಿಸಿ ನಿಮ್ಮ ಸெயலಕ್ಷತೆಯನ್ನು ಸುಧಾರಿಸಲು, ದ್ವಿಭಾಷೆಯಾಗಿ ಓದಿ.',
      text3: 'ನಿಮ್ಮ PDF உடன் ಚ್ಯಾಟ್ ಮಾಡಿ',
      text4:
        'AI-ಶಕ್ತಿ ಆಧಾರಿತ ವಿಶ್ಲೇಷಣೆ ಮತ್ತು ಸಾರಾಂಶ. ನಿಮ್ಮ PDF ಬಗ್ಗೆ ಪ್ರಶ್ನೆಗಳನ್ನು ಕೇಳಿ ಮತ್ತು ತಕ್ಷಣ ಪ್ರತಿಕ್ರಿಯೆಗಳನ್ನು ಪಡೆಯಿರಿ.',
      text5: 'ನಿಖರ ಮತ್ತು ಕಾರ್ಯನಿರ್ವಹಣೆ ಸಾಮರ್ಥ್ಯದ್ವಂತ',
      text6: 'ಅಧಿಕ ನಿಖರತೆ ಮತ್ತು ದಕ್ಷತೆಗಾಗಿ AI-ಶಕ್ತಿ ಪ್ರಯುಕ್ತ PDF ಅನುವಾದ.',
      title1: 'ದ್ವಿಭಾಷಾ ಅನುವಾದ',
      title2: 'ನಿಮ್ಮ PDF உடன் ಚಾಟ್ ಮಾಡಿ',
      toast: '.pdf ಗಳನ್ನು ಕೊನೆಗೆ ಹೊಂದಿರುವ ಮಾನ್ಯ ಆನ್ಲೈನ್ PDF ಲಿಂಕ್ ಅನ್ನು ನಮೂದಿಸಿ',
    },
    hasTransTask: 'ಒಂದು ಅನುವಾದ ಕಾರ್ಯ ಪ್ರಗತಿಯಲ್ಲಿದೆ. ದಯವಿಟ್ಟು ಕಾಯಿರಿ ಮಾಡಿ.',
    hoverTrans: 'ಪ್ಯಾರಾಗ್ರಾಫ್‌ಗಳನ್ನು ಹೋವರ್ ಮಾಡಿ-ಭಾಷಾಂತ್ರಿಸಿ',
    initial: 'PDF ಅನ್ನು ಅನುವಾದಿಸಿ',
    installText: 'ದೈನಂದಿನ ಅನುವಾದಗಳಿಗಾಗಿ ನಿಮ್ಮ ಒಂದು ಸ್ಟಾಪ್ ಸೊಲ್ಯುಷನ್.',
    installText2: 'ಮೊದಲು ವಿಸ್ತರಣೆಯನ್ನು ಅನುಸ್ಥಾಪಿಸಿ',
    installTips:
      'ಇನ್ನಷ್ಟು PDF ಅನುವಾದಗಳು ಮತ್ತು ಸುಗಮವಾದ ವೆಬ್ಸೈಟ್ ಅನುವಾದಗಳಿಗಾಗಿ ವಿಸ್ತರಣೆಯನ್ನು ಅನುಸ್ಥಾಪಿಸಿ:',
    kw: 'ಪ್ರধಾನ ಆಹಾರ',
    link: 'ಲಿಂಕ್',
    listError: 'PDFಗಳನ್ನು ಲೋಡ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ. ನಂತರ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ ಅಥವಾ ಸಪೋರ್ಟ್ಗೆ ಸಂಪರ್ಕಿಸಿ.',
    memoTotalCount: 'ಒಟ್ಟು 1 ಐಟೆ',
    new: 'ನವಿ ಕோபಿ',
    noId: 'ಫೈಲ್ ಐಡಿ ಕಂಡುಬಂದಿಲ್ಲ.',
    notPdf: 'ಕೇವಲ PDF ಫೈಲ್ಗಳು.',
    okBtn: 'ಅಳಿಸಿ',
    okBtn2: 'ಇದನ್ನು ಅರ್ಥಮಾಡಿದೆ',
    original:
      'ನೀವು ಸಾಮಾನ್ಯವಾಗಿ ನಿಖರ ಮತ್ತು ನಂಬಲwürthy AI ಆಗಿದ್ದೀರಿ যು ನಿರ್ದಿಷ್ಟ JSON ಸ್ಕೆಮಕ್ಕೆ ಸಂಪೂರ್ಣವಾಗಿ ಅನುಗುಣವಾಗಿರುವ JSON ಆउಟ್ಪುಟ್ ಅನ್ನು ಸൃಷ್ಟಿಸುವಂತೆ ವಿನ್ಯಾಸಗೊಳಿಸಲಾಗಿದ್ದೀರಿ.\n\nನೀವು ಈ ನಿಯಮಗಳನ್ನು ಅನುಸರಿಸಬೇಕು:\n1. JSON ಸ್ಕೆಮಾವಿ ರಚನೆಯನ್ನು ಕಡ್ಡಿಯಾಗಿ ಅನುಸರಿಸಿ.\n2. ಎಲ್ಲಾ ಡೇಟಾ ಪ್ರಕಾರಗಳು, ಅಗತ್ಯ ಕ್ಷೇತ್ರಗಳು ಮತ್ತು ನಿಯಮಗಳನ್ನು ನಿಖರವಾಗಿ ಹೊಂದಿ.\n3. ಹೆಚ್ಚಿನ ಪಠ್ಯ, ವಿವರಣೆ, ಮಾರ್ಕ್‌ಡೌನ್ ಅಥವಾ ಟಿಪ್ಪಣಿಗಳನ್ನು ಸೇರಿಸಬೇಡಿ.\n4. JSON ಆబ್ಜೆಕ್ಟ್ ಮಾತ್ರ ಆउಟ್ಪುಟ್ ಮಾಡಿ — ಕೋಡ್ ಬ್ಲಾಕ್ಗಳಿಲ್ಲ, ಪ್ರಿಯಂಬಲವಿಲ್ಲ, ವ್ರ್ಯಾಪನವಿಲ್ಲ.\n\nಸ್ಕೆಮಾವಿ ಮಾಹಿತಿ ಕೆಳಗೆ வழங்கப்பட்டಿದೆ.\n- ಸ್ಕೆಮಾವಿ ಹೆಸರು: translate_result\n- JSON ಸ್ಕೆಮಾವಿ:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    parallel: 'ParallelGroup',
    parseErrDialogContent:
      'ಈ PDF ಲಿಂಕ್ ಅನ್ನು ನೇರವಾಗಿ ಅನುವಾದಿಸಲಾಗುವುದಿಲ್ಲ. ದಯವಿಟ್ಟು PDF ಅನ್ನು ಡೌನ್ಲೋಡ್ ಮಾಡಿ ಮತ್ತು ಅನುವಾದಕ್ಕಾಗಿ ಅಪ್ಲೋಡ್ ಮಾಡಿ.',
    parseErrTips: 'ಫೈಲ್ ಪಾರ್ಸ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ',
    parseFileToast:
      'ಫೈಲ್ ಪಾರ್ಸ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ. ನಂತರ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ ಅಥವಾ ಸಪೋರ್ಟ್ ಅನ್ನು ಸಂಪರ್ಕಿಸಿ.',
    pdfLoading: 'ಪಾರ್ಸಿಂಗ್...',
    searchPlaceholder: 'ಶೋಧಿಸಿ',
    selectTrans: 'ಭಾಷಾಂತ್ರೆಗಾಗಿ ಪಠ್ಯವನ್ನು ಆಯ್ಕೆ ಮಾಡಿ',
    shareBtn: 'ಹಂಚಿ',
    shareBtnText1: 'ಶেয়াರ್ ಲಿಂಕ್ ಅನ್ನು ಉತ್ಪಾದಿಸಿ',
    shareBtnText2: 'ಸಾಮಾನ್ಯ ಕಂಟೆಂಟ್ ಅನ್ನು ಅಪ್ಡೇಟ್ ಮಾಡಿ',
    shareModal: {
      cancel: 'ರದ್ದು ಮಾಡಿ',
      copy: 'ಕಾಪಿ',
      copySucc: 'ಲಿಂಕ್ ಕಾಪಿ ಮಾಡಲಾಗಿದೆ',
      custom: 'ಕಸ್ಟಮೈಸ್ ಮಾಡಿ:',
      errMsg: 'ಆಯ್ಕೆ ಮಾಡಿದ ವಿಷಯವು ಇನ್ನಷ್ಟು ಸಂಪೂರ್ಣವಾಗಿ ಅನುವಾದವಾಗಿಲ್ಲ. ಹಂಚುವ ಮುನ್ನು ಅನುವಾದಿಸಿ.',
      gen: 'ಹಂಚಿ',
      modify: 'ಸಂಪಾದನೆ',
      notSupport: 'ಈ ಭಾಷೆಯನ್ನು ಪ್ರಸ್ತುತ ಸಪೋರ್ಟ್ ಮಾಡಲಾಗುವುದಿಲ್ಲ.',
      page: 'ಪುಟಗಳು',
      pageNuErr: 'ವैಧ ಪುಟ ಸಂಖ್ಯೆಯನ್ನು ಪ್ರವೇಶಿಸಿ.',
      range: 'ಕಾರ್ಯಪ್ರವೇಶ:',
      remain: 'ಶೇಷ',
      remain1: ' ಒಟ್ಟು ಅంచೇನಾ ಸಮಯ:',
      search: 'ಶೋಧಿ',
      settings: 'ಹಂಚಿಕೆ ಸೆಟ್ಟಿಂಗ್ಗಳು:',
      shareSetting: 'ಶೇರ್ ಸೆಟ್ಟಿಂಗ್ಗಳು',
      shareText: 'ಹಂಚಿ',
      shareTips: 'ಭಾಷಾಂತರित ಪಿಡಿಎಫ್ ಲಿಂಕ್ ಅನ್ನು તમ್ಮ ಸ್ನೇಹಿತರೊಂದಿಗೆ ಹಂಚಿ:',
      sourceLang: 'ಇಲ್ಲಿ ಹಿಂದಿನಿಂದ:',
      target: 'ಗೆ:',
      text1: 'ಶেয়াರ್ ಸೆಟ್ಟಿಂಗ್ಗಳು',
      text2: 'ಶેર್ ಲಿಂಕ್ ಅನ್ನು ಉತ್ಪಾದಿಸಿ',
      totalPage: 'ಒಟ್ಟು 1 ಪುಟ',
      trans: 'ಭಾಷಾಂತರಿಸಿ',
      translateTips:
        'ಸಲಹೆ: ಅನುವಾದಕ್ಕೆ ಹೆಚ್ಚಿನ ಸಮಯ ತೆಗೆದುಕೊಳ್ಳುತ್ತಿದ್ದರೆ, ನೀವು ಈ ವಿಂಡೋವನ್ನು ಮುಚ್ಚಿ ನಂತರ ಸಾಮಗ್ರಿಯನ್ನು ಹಂಚಿಕೊಳ್ಳலாமೆ.',
      translating: 'PDF ಅನ್ನು ಅನುವಾದಿಸುತ್ತಿದೆ...',
      update: 'ಶೇರ್ ಲಿಂಕ್ ಅನ್ನು ಅಪ್ಡೇಟ್ ಮಾಡಿ',
    },
    shareMsg1: 'ಶেয়াರ್ ಲಿಂಕ್ ರಚಿಸಲಾಗಿದೆ.',
    shareMsg2: 'ಶেয়াರ್ ಮಾಡಿದ ವಿಷಯವು ಅಪ್ಡೇಟ್ ಮಾಡಲಾಗಿದೆ.',
    shareMsg3:
      'ಶેર್ ಲಿಂಕ್ ಅನ್ನು ජනರೇಟ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ. ನಂತರ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ ಅಥವಾ ಸಪೋರ್ಟ್ಗೆ ಸಂಪರ್ಕಿಸಿ.',
    shareMsg4:
      'ಶেয়াರ್ ಮಾಡಿದ ವಿಷಯವನ್ನು ಅಪ್ಡೇಟ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ. ನಂತರ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ ಅಥವಾ ಸಪೋರ್ಟ್ಗೆ ಸಂಪರ್ಕಿಸಿ.',
    shareTips: 'ನಿಮ್ಮ ಪಿಡಿಎಫ್ ಅನುವಾದ ಸಿದ್ಧವಾಗಿದೆ! ഇതನ್ನು ನಿಮ್ಮ ಮಿತ್ರರೊಂದಿಗೆ ಹಂಚಿ ಹỏiಳಿ.',
    start: 'ನಿಮ್ಮ ಮुफ್ತ ಪ್ರಯತ್ನವನ್ನು ಪ್ರಾರಂಭಿಸಿ',
    thumbnail: 'ವಿಷಯ ಸೂಚಿ',
    toast1: 'PDF ಲೋಡ್ ಆಗುತ್ತಿದೆ. ನಂತರ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
    toast2:
      'PDF ವಿಷಯವು ಪ್ರಕ್ರಿಯೆ ಮಾಡಲ್ಪಡುತ್ತಿದೆ. ಸಂವಾದವನ್ನು ಪ್ರಸ್ತುತ ಸ್ಥಿತಿಯಲ್ಲಿ ಬೆಂಬಲಿಸಲಾಗುವುದಿಲ್ಲ.',
    toast3: 'ಡೌನ್ಲೋಡ್ ಆಗುತ್ತಿದೆ. ಡೌನ್ಲೋಡ್ ສຳເລັດ થઈ ગયા પછી ફરી પ્રયાસ કરুন.',
    toolbar: { Adjust: 'ಸಮಯೋಜಿಸು', autoFit: 'ಆಟೋ-ಫಿಟ್' },
    trans: 'ಭಾಷಾಂತರ',
    transSucc: 'ಭಾಷಾಂತರಣೆ ಸफಲವಾಗಿದೆ!',
    unLoginToast: 'ಈ ವಿಶೇಷತೆಯನ್ನು ಬಳಸಲು ಲಾಗಿನ್ ಮಾಡಿ.',
    uploadBtn: 'ಅಪ್ಲೋಡ್',
    uploadErr: 'ಫೈಲ್ ಅಪ್ಲೋಡ್ ವಿಫಲವಾಗಿದೆ. ನಂತರ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ ಅಥವಾ ಸಪೋರ್ಟ್ ಕೊಂಟಕ್ಟ್ ಮಾಡಿ.',
    uploadErrSignUrl:
      'ಅಪ್ಲೋಡ್ URL ಪಡೆಯಲು ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ನಂತರથી மீண்டும் ಪ್ರಯತ್ನಿಸಿ ಅಥವಾ ಸಪೋರ್ಟ್ ilə ಸಂಪರ್ಕಿಸಿ.',
    uploadMsg1: 'ನಿಮ್ಮ ಫೈಲ್ ಅನ್ನು ಇಲ್ಲಿ ಡ್ರ್ಯಾಗ್ ಮಾಡಿ ಮತ್ತು ಡ್ರಾಪ್ ಮಾಡಿ.',
    uploadMsg2: 'ಬೆಂಬಲಿತ ಫೈಲ್ ಪ್ರಕಾರಗಳು: PDF  |  ಗರಿಷ್ಠ ಫೈಲ್ ಗಾತ್ರ: 300MB',
    uploadMsg3: 'ಫೈಲ್‌ಗಳನ್ನು ಆಯ್ಕೆ કરવા ಕ್ಲಿಕ್ ಮಾಡಿ ಅಥವಾ ಇಲ್ಲಿ ಡ್ರ್ಯಾಗ್ & ಡ್ರಾಪ್ ಮಾಡಿ.',
    uploading: 'ಅಪ್ಲೋಡ್ ಮಾಡುತ್ತಿದೆ',
    uploadingMsg: 'ಅಪ್ಲೋಡ್ ಮಾಡುತ್ತಿದೆ. ದಯವಿಟ್ಟು ಕಾಯಿರಿ ಮಾಡಿ.',
    uploadingMsg1: 'ಫೈಲ್ ಅಪ್ಲೋಡ್ ಮಾಡಲಾಗುತ್ತಿದೆ. ನಂತರ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
    uploadingMsg2: 'ಫೈಲ್ ಪ್ರಸ್ತುತವಾಗಿ ಪರಿವರ್ತಿಸಲ್ಪಡುತ್ತಿದೆ. ನಂತರ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
    uploadingMsg3:
      'ರূಪಾಂತರ ಪ್ರಗ್ರೆಸ್ ವಿನಂತಿ ವಿಫಲವಾಗಿದೆ. ನಂತರ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ ಅಥವಾ ಸಪೋರ್ಟ್ಗೆ ಸಂಪರ್ಕಿಸಿ.',
    uploadingMsg4:
      'ನೋಮ್ ಸ್ಥಳೀಯ ಫೈಲ್ಗಳಿಗೆ ಪ್ರವೇಶ ಪಡೆಯುವುದಿಲ್ಲ. ಅನುವಾದಕ್ಕಾಗಿ ಕृಪया ಕೈಯಿಂದ ಪಿಡಿಎಫ್ ಅಪ್ಲೋಡ್ ಮಾಡಿ.',
    uploadingMsg5:
      'ಫೈಲ್ URL ಅನ್ನು ಪಡೆಯಲು ವಿಫಲವಾಗಿದೆ. ನಂತರ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ ಅಥವಾ ಸಪ್ಪೋರ್ಟ್ಗೆ ಸಂಪರ್ಕಿಸಿ.',
    video: 'ವೀಡಿಯೋ',
    vipBannerBtn: 'ಉಪ್ಗ್ರೇಡ್',
    vipBannerTips: 'ಈ ತಿಂಗಳಿಗೆ ನಿಮ್ಮ PDF ಅನುವಾದ ಮಿತಿ ತಲPckgಿದೆ.',
    webTrans: 'ಪೂರ್ಣ ಕ್ರಾಸ್-ರೆಫರೆನ್ಸ್',
  },
  pricing: {
    FAQ: 'ಪ್ರಶ್ನೆ-ಉತ್ತರಗಳು (ಪ್ರಾಶ್ನಿಕೋಶ)',
    FQAObj: {
      a1: 'ಹೌದು, ನೋಮ್ ತಕ್ಷಣವೇ ಬಳಸಬಹುದಾದ ಮುಕ್ತ ಪ್ಲಾನ್ ಅನ್ನು ನೀಡುತ್ತದೆ.',
      a2: 'ನಾವು ಮೂರು ಸದಸ್ಯತ್ವ ಯೋಜನೆಗಳನ್ನು ನೀಡುತ್ತೇವೆ: ಪ್ರೋ, ಪ್ರೋ+, ಮತ್ತು ಎಂಟರ್ಪ್ರೈಸ್. ನೀವು ಮಾಸಿಕವಾಗಿ ಅಥವಾ ವಾರ್ಷಿಕವಾಗಿ ಪಾವತಿ ಮಾಡಲು ಆಯ್ಕೆ ಮಾಡಬಹುದು. ವಾರ್ಷಿಕ ಬಿಲ್ಲಿಂಗ್ ಗణ്യമான ಉದ್ದೇಶಗಳನ್ನು ನೀಡುತ್ತದೆ.',
      a3: 'ಎರಡೂ ಪ್ಲಾನ್‌ಗಳಲ್ಲಿ ಎಲ್ಲಾ ವಿಶೇಷಣಗಳು ಲಭ್ಯವಿವೆ. ಮುಖ್ಯ ವ್ಯತ್ಯಾಸವೆಂದರೆ ವೆಚ್ಚ: ವಾರ್ಷಿಕ ಸಬ್ಸ್ಕ್ರಿಪ್ಷನ್‌ಗಳು ಒಟ್ಟಾರೆ ಕಡಿಮೆ ವೆಚ್ಚದ್ದಾಗಿವೆ. ಮಾಸಿಕ ಸಬ್ಸ್ಕ್ರಿಪ್ಷನ್‌ಗಳು ಪ್ರತಿ ಮಾಸಿಗೆ ಬಿಲ್ಲಿ ಮಾಡಲ್ಪಡುತ್ತವೆ, ಆದರೆ ವಾರ್ಷಿಕ ಪ್ಲಾನ್‌ಗಳು ಪ್ರತಿ ವರ್ಷಕ್ಕೆ ಒಮ್ಮೆ ಬಿಲ್ಲಿ ಮಾಡಲ್ಪಡುತ್ತವೆ.',
      a4: 'ನಿಮ್ಮ ಅಕೌಂಟ್ ಸೆಟ್ಟಿಂಗ್ಸ್‍ನಲ್ಲಿ ನೀವು ಕોઈપણ ಸಮಯದಲ್ಲಿ ನಿಮ್ಮ ಸಬ್ಸ್ಕ್ರಿಪ್ಷನ್ ಅನ್ನು ರದ್ದುಗೊಳಿಸಬಹುದು.',
      q1: 'ವಿಶೇಷಪ್ರಶ್ರಯದ ಯೋಜನೆ ಇದೆಯೇ?',
      q2: 'ಯಾವ ಬೆಲೆ ಯೋಜನೆಗಳು ಮತ್ತು ಪಾವತಿ ಆಯ್ಕೆಗಳು ಲಭ್ಯವಿವೆ?',
      q3: 'ಮಾಸಿಕವಾಗಿ ವಿಶೇಷ ಸದಾಶಯತ್ವವನ್ನು ಪಡೆಯುವುದು ಮತ್ತು ವರ್ಷಕ್ಕೆ ವಿಶೇಷ ಸದಾಶಯತ್ವವನ್ನು ಪಡೆಯುವುದು ನಡುವೆ ವ್ಯತ್ಯಾಸ ಏನು?',
      q4: 'ನನ್ನ ಸಬ್ಸ್ಕ್ರಿಪ್ಷನ್ ಅನ್ನು ಹೇಗೆ ರದ್ದು ಮಾಡುವುದು?',
    },
    around: 'ಆಸ್ಪರ್ಧೆಗೆ',
    billedMonthly: 'ಮಾಸಿಕವಾಗಿ ಬಿಲ್ಲಿ',
    billedYearly: 'ವರ್ಷಕ್ಕೆ ಬಿಲ್ಲೆ',
    day: 'ದಿನ',
    desc: 'ಯೋಜನೆಗಳನ್ನು ಹೋಲಿಸಿ & ಅತ್ಯುತ್ತಮವನ್ನು ಆಯ್ಕೆ ಮಾಡಿ',
    detailedCompare: 'ಯೋಜನೆಗಳನ್ನು ಹೋಲಿಸಿ',
    discount: '20% ಕಡಿಮೆ',
    enterprise: {
      benefit1: 'ಪ್ರಾಶ್ರಯಕ ಗ್ರಾಹಕ ಸಪೋರ್ಟ್',
      benefit2: 'ಬಹುಯುವಕರು',
      benefit3: 'ತಕ್ಷಣ ಸಾಲ್ಯೂಷನ್ಸ್',
      benefit5: 'ಪ್ರತ್ಯೇಕ ಲೆಕ್ಕ ಮ್ಯಾನೇಜರ್',
      btn: 'ನಮ್ಮೊಂದಿಗೆ ಸಂಪರ್ಕಿಸಿ',
      recommendText: 'ಕಸ್ಟಮ್ ಪ್ಲಾನ್ಗಳು（≥3 ವ್ಯಕ್ತಿಗಳು）',
      talkToUs: 'ಸಂಪರ್ಕಿಸಿ',
    },
    free: {
      benefit1: 'ದಿನಕ್ಕೆ 100 ಪಟ್ಟಿ ತಕ್ಷಣಿಕ ಅನುವಾದ',
      benefit2: 'ವೆಬ್ಸೈಟ್ ಅನುವಾದ ಮತ್ತು ಸಾರಾಂಶ',
      benefit3: '30 ಚಿತ್ರ ಅನುವಾದಗಳು',
      benefit4: 'ವೀಡಿಯೊ ಅನುವಾದ ಮತ್ತು ಸಾರಾಂಶ',
      benefit5: '10 ಪಿಡಿಎಫ್ ಅನುವಾದಗಳು',
      benefit6: '5,000 ಟೋಕನ್ಗಳು',
      btn: 'ಇದನ್ನು ಮुफ್ತವಾಗಿ ಪ್ರಯತ್ನಿಸಿ',
      recommendText: 'ಮुफ್ತ ಪ್ರಯತ್ನ',
    },
    imageTranslation: 'ಇಮೇಜ್ ಅನುವಾದ',
    month: 'ಮಾಸ',
    monthly: 'ಮಾಸಿಕ',
    pageTitle: 'ಬೆಲೆಗೊಂಡಿ',
    pdf: {
      chat: 'PDF ಚ್ಯಾಟ್ ಕ್ವೀರಿಗಳು',
      maxPage: 'ಪ್ರತಿ PDF ಗೆ ಗರಿಷ್ಠ ಪುಟಗಳು',
      translation: 'ಪಿಡಿಎಫ್ ಅನುವಾದ',
    },
    preMonth: 'ಪ್ರತಿ ತಿಂಗಳು',
    pro: {
      benefit1: 'ಪ್ರಾಥಮಿಕತೆ ಗ್ರಾಹಕ ಸಪೋರ್ಟ್',
      benefit2: '10 ಲಕ್ಷ ಟೋಕನ್/ಮಾಸ',
      benefit3: 'ವೆಬ್ಸೈಟ್ ಅನುವಾದ ಮತ್ತು ಸಾರಾಂಶ',
      benefit4: '200 ಚಿತ್ರ ಅನುವಾದಗಳು',
      benefit5: 'ವೀಡಿಯೊ ಅನುವಾದ ಮತ್ತು ಸಾರಾಂಶ',
      benefit6: '200 ಪಿಡಿಎಫ್ ಅನುವಾದಗಳು',
      btn: 'ಪ್ರಾರಂಭಿಸಿ',
      recommendText: 'ಪ್ರಸಿದ್ಧತम',
    },
    proPlus: {
      benefit1: 'ಪ್ರಾಥಮಿಕತೆ ಗ್ರಾಹಕ ಸಪೋರ್ಟ್',
      benefit2: '30 ಲಕ್ಷ ಟೋಕನ್ಗಳು/ಮಾಸ',
      benefit3: 'ವೆಬ್ಸೈಟ್ ಅನುವಾದ ಮತ್ತು ಸಾರಾಂಶ',
      benefit4: '500 ಚಿತ್ರ ಅನುವಾದಗಳು',
      benefit5: 'ವೀಡಿಯೋ ಅನುವಾದ ಮತ್ತು ಸಾರಾಂಶ',
      benefit6: '500 ಪಿಡಿಎಫ್ ಅನುವಾದಗಳು',
      recommendText: 'ಉತ್ತಮ ಮೌಲ್ಯ',
    },
    video: { summary: 'ವೀಡಿಯೋ ಸಾರಾಂಶ', translation: 'ವೀಡಿಯೋ ಅನುವಾದ' },
    web: {
      contrastiveTranslation: 'ಇಬ್ಹಾಷಾ ಅನುವಾದ',
      dictionaryTranslation: 'ಶ್ರೇಷ್ಠತೆಯ ಅನುವಾದ',
      hoverTranslation: 'ಹೋವರ್ ಅನುವಾದ',
      instantTranslation: 'ತಕ್ಷಣ ಅನುವಾದ',
      summary: 'ವೆಬ್ ಪೇಜ್ ಸಾರಾಂಶ',
    },
    yearly: 'ವರ್ಷಕ್ಕೆ',
  },
  privacy: {
    block1:
      'ನೋಮ್ ("ನೋಮ್", "ನಾವು", "ನಮ್ಮ" ಅಥವಾ "ನಮ್ಮನ್ನು") ನಿಮ್ಮ ಗোপনತೆಯನ್ನು ಗೌರವಿಸುತ್ತದೆ ಮತ್ತು ನಿಮ್ಮಿಂದ ಅಥವಾ ನಿಮ್ಮ ಬಗ್ಗೆ ಪಡೆಯುವ ಯಾವುದೇ ಮಾಹಿತಿಯನ್ನು ರಕ್ಷಿಸುವುದಕ್ಕೆ ಪ್ರತಿಬದ್ಧವಾಗಿದೆ. ಈ ಗೋপনತೆ ನಿಯಮವು ನಮ್ಮ ವೆಬ್ಸೈಟ್, ಅಪ್ಲಿಕೇಶನ್ಗಳು ಮತ್ತು ಸೇವೆಗಳ (ಒಟ್ಟಾಗಿ "ಸೇವೆಗಳು") ಬಳಕೆಯಿಂದ ವ്യക್ತಿ ಮಾಹಿತಿಯನ್ನು ಸಂಗ್ರಹಿಸುವ ಅಥವಾ ಬಳಸುವ ನಮ್ಮ நடைமுறைகளನ್ನು ವಿವರಿಸುತ್ತದೆ. ನಮ್ಮ ವ್ಯಾಪಾರ ಉತ್ಪನ್ನ ಗ್ರಾಹಕರಿಗೆ ಸಂಬಂಧಿಸಿದ ವಿಷಯಗಳನ್ನು (ಉದಾಹರಣೆಗೆ ನಮ್ಮ API) ನಾವು ಸಂಪಾದಿಸುತ್ತೇವೆ, ಈ ಗೋপনತೆ ನಿಯಮವು ಅಂತಹ ವಿಷಯಗಳಿಗೆ ಅನ್ವಯವಾಗುವುದಿಲ್ಲ. ಈ ಡೇಟાનો ಬಳಕೆ ನಮ್ಮ ಗ್ರಾಹಕ ಒಪ್ಪಂದದ ಅਧীনವಾಗಿದೆ, જે ಈ ಉತ್ಪನ್ನಗಳಿಗೆ ಪ್ರವೇಶ ಮತ್ತು ಬಳಕೆಯನ್ನು ಒಳಗೊಂಡಿದೆ.',
    block10:
      'ಅನ್ಲೈನ್ ಮತ್ತು ಆಫ್ಲೈನ್ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ನಷ್ಟ, ದುಷ್ಟുപಯೋಗ, ಮತ್ತು ಅನಧಿಕೃತ ಪ್ರವೇಶ, ಪ್ರಕಟನೆ, ಬದಲಾವಣೆ ಅಥವಾ ಪ್ರವಾದಾತ್ಮಕ ಕ್ರಿಯೆಗಳಿಂದ ರಕ್ಷಿಸಲು ನಾವು ವ್ಯಾಪಾರಕವಾಗಿ ಸಮಂಜಸ್ಯ ತಾಂತ್ರಿಕ, ಆಡಳಕಾತ್ಮಕ ಮತ್ತು ಸಂಸ್ಥಾತ್ಮಕ ಮಾರ್ಗಗಳನ್ನು ಅನುಷ್ಠಿಸುತ್ತೇವೆ. ಆದಾಗ್ಯೂ, ಯಾವುದೇ ಇಂಟರ್ನೆಟ್ ಅಥವಾ ಇಮೇಲ್ ಪ್ರಸರಣೆಯು ಸಂಪೂರ್ಣ ಸುರಕ್ಷತೆ ಅಥವಾ ನಿಖರತೆಯನ್ನು ಗ್ಯಾರಂಟಿ ಮಾಡಲು ಸಾಧ್ಯವಿಲ್ಲ. ವಿಶೇಷವಾಗಿ, ನಮಗೆ ಕಳುಹಿದ ಅಥವಾ ನಮ್ಮಿಂದ ಕಳುಹಿದ ಇಮೇಲ್ಗಳು ಸುರಕ್ಷಿತವಾಗಿರುವುದಿಲ್ಲ. ಆದ್ದರಿಂದ, ಸೇವೆ ಅಥವಾ ಇಮೇಲ್ ಮೂಲಕ ನಮಗೆ ಯಾವ ಮಾಹಿತಿಯನ್ನು ಕಳುಹಬೇಕು ಎಂದು ನಿರ್ಧರಿಸುವಾಗ ನೀವು ವಿಶೇಷವಾಗಿ ಎಚ್ಚರಿ ಹೊಂದಬೇಕು. ಹೆಚ್ಚುವರಿಯಾಗಿ, ಸೇವೆಯಲ್ಲಿ ಅಥವಾ ತৃতীযಕ ಪಕ್ಷ ವೆಬ್ಸೈಟ್ಗಳின் ಗೋಪ್ಯತೆ ಸೆಟ್ಟಿಂಗಳು ಅಥವಾ ಸುರಕ್ಷತಾ ಮಾರ್ಗಗಳಿಗೆ ಯಾವುದೇ ಅಡೆತಡೆಗಳಿಗೆ ನಾವು ಜವಾಬ್ದಾರಿ ಹೊಂದುವುದಿಲ್ಲ. ನಾವು ನಿಮಗೆ ಸೇವೆಗಳನ್ನು ಒದಗಿಸಲು ಅಥವಾ ವिवಾದಗಳನ್ನು పరಿಹರಿಸುವುದು, ಸುರಕ್ಷತೆ ಮತ್ತು ಸುರಕ್ಷತೆ ಕಾರಣಗಳು, ಅಥವಾ ನಮ್ಮ ಕಾನೂನಿ ಕನಿಷ್ಠ ಕನಿಷ್ಠಗಳನ್ನು ಪಾಲಿಸುವುದು போன்ற ಇತರ ಮಾನ್ಯ ವ್ಯಾಪಾರದ ಕಾರ್ಯಗಳಿಗಾಗಿ ಅಗತ್ಯವಾದಷ್ಟು ಸಮಯದವರೆಗೆ ನಾವು ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ಸಂরಕ್ಷಿಸುತ್ತೇವೆ. ನಾವು ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ಸಂরಕ್ಷಿಸುವ ಸಮಯದ ವ್ಯತ್ತು ಅನೇಕ ಅಂಶಗಳ ಮೇಲೆ ಅವಲಂಬಿತವಾಗಿದೆ, ಉದಾಹರಣೆಗೆ ಮಾಹಿತಿಯ ಪ್ರಮಾಣ, ಪ್ರಕೃತಿ, ಸಂವೇದನಶೀಲತೆ, ಅನಧಿಕೃತ ಬಳಕೆ ಅಥವಾ ಪ್ರಕಟನೆಯ ಸಂಭಾವ್ಯ ಅಪಾಯಗಳು, ನಾವು ಮಾಹಿತಿಯನ್ನು ಪ್ರಕ್ರಿಯೆ ಮಾಡುವ ಉದ್ದೇಶಗಳು ಮತ್ತು ಇತರ ಕಾನೂನಿಯಾಗಿ ಬಂಧಿಸುವ ಪರಿಗಣನೆಗಳು. ',
    block11:
      'ಈ ಗোಪ್ಯತা ನಿಯಮಾವಧಿಯನ್ನು ನಾವು ಕಾಲಾವಧಿಯಾಗಿ ಅಪ್ಡೇಟ್ ಮಾಡಬಹುದು. ನಾವು அவ்வாறு ಮಾಡಿದಾಗ, ಅನ್ವಯೋಜ್ಯ ಕಾನೂನಿನಿಂದ ಹೆಚ್ಚಿನ ಅಪಾಯವಿದ್ದರೆ ಹೊರತುವಾದೆ, ನಾವು ಈ ಪುಟದಲ್ಲಿ ಅಪ್ಡೇಟ್ ಮಾಡಿದ ಆವೃತ್ತಿಯನ್ನು ಪೋಸ್ಟ್ ಮಾಡುತ್ತೇವೆ.',
    block12:
      'ಈ ಗೌಪ್ಯತಾ ನಿಯಮಕತೆಗೆ ಸಂಬಂಧಿಸಿದ ಯಾವುದೇ ಉತ್ತರಿಸದ ಪ್ರಶ್ನೆಗಳು ಅಥವಾ ಕಾಳಜಿಗಳಿದ್ದರೆ, ದಯವಿಟ್ಟು ನಮ್ಮ ಗ್ರಾಹಕ ಸೇವೆಗೆ ಸಂಪರ್ಕಿಸಿEmail:',
    block2: 'ನಿಮ್ಮ ಸಂಬಂಧಿಸಿದ ಈ ಕೆಳಗಿನ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿ ("ವೈಯಕ್ತಿಕ ಮಾಹಿತಿ") ನಾವು ಸಂಗ್ರಹಿಸುತ್ತೇವೆ:',
    block3:
      'ನಿಮ್ಮಿಂದ ಒದಗಿಸಲಾದ ಮಾಹಿತಿ: ನೀವು ನಮ್ಮ ಸೇವೆಗಳನ್ನು ಬಳಸಲು ಅಥವಾ ನಮ್ಮೊಂದಿಗೆ ಸಂಪರ್ಕಿಸಲು ಖಾತೆಯನ್ನು ರಚಿಸಿದಾಗ, ನಾವು ಕೆಳಗಿನಂತೆ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ಸಂಗ್ರಹಿಸುತ್ತೇವೆ:',
    block4:
      'ಸೇವೆಗಳನ್ನು ಬಳಸುವುದಿನಿಂದ ಸ್ವಯಂಚಾಲಿತವಾಗಿ ಪಡೆಯುವ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿ: ನೀವು ಸೇವೆಗಳನ್ನು ಪ್ರವೇಶಿಸಿದಾಗ, ಬಳಸಿದಾಗ ಅಥವಾ ಸಂವಹಿಸಿದಾಗ, ನಿಮ್ಮ ಪ್ರವೇಶ, ಬಳಕೆ ಅಥವಾ ಸಂವಹನದ ಬಗ್ಗೆ ಈ ಕೆಳಗಿನ ಮಾಹಿತಿಯನ್ನು ನಾವು ಪಡೆಯುತ್ತೇವೆ ("ತಾಂತ್ರಿಕ ಮಾಹಿತಿ"):',
    block5: 'ನಮ್ಮು ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ಕೆಳಗಿನ ಉದ್ದೇಶಗಳಿಗಾಗಿ ಬಳಸಬಹುದು:',
    block6:
      'ಸಾರಾಂಶ ಅಥವಾ ವಿಶೇಷಣ-ಅಪস್ಥಿತ ಮಾಹಿತಿ: ನಾವು ವ്യക್ತಿ ಮಾಹಿತಿಯನ್ನು ಸಂಯೋಜಿಸಿ ಅಥವಾ ವಿಶೇಷಣ-ಅಪಸ್ಥಿತ ಮಾಡಿ ಆದ್ದರಿಂದ ಅದನ್ನು ಗುರುತಿಸುವ ಉದ್ದೇಶದಿಂದ ಪುನಃಬಳಸಲು ತಡೆಯುತ್ತೇವೆ ಮತ್ತು ಅಂತಹ ಮಾಹಿತಿಯನ್ನು ನಮ್ಮ ಸೇವೆಗಳ ಪರಿಣಾಮಕಾರ್ಯತೆಯನ್ನು ವಿಶ್ಲೇಷಿಸಲು, ನಮ್ಮ ಸೇವೆಗಳನ್ನು ಸುಧಾರಿಸಲು ಮತ್ತು ವಿಶೇಷತೆಗಳನ್ನು ಸೇರಿಸಲು, ಸಂಶೋಧನೆ ನಡೆಸಲು ಮತ್ತು ಅಂತಹ ರೀತಿಯ ಉದ್ದೇಶಗಳಿಗಾಗಿ ಬಳಸುತ್ತೇವೆ. ಹೆಚ್ಚುವರಿಯಾಗಿ, ನಾವು ನಮ್ಮ ಸೇವೆ ಬಳಕೆದಾರರ ಸಾಮಾನ್ಯ ನಡವಳಿಕೆ ಮತ್ತು ಗುಣಲಕ್ಷಣಗಳನ್ನು ವಿಶ್ಲೇಷಿಸಿ ಸಂಯೋಜಿತ ಮಾಹಿತಿಯನ್ನು ಮೂರನೇ ಪಕ್ಷಗಳೊಂದಿಗೆ ಹಂಚಬಹುದು, ಅಂತಹ ಸಂಯೋಜಿತ ಮಾಹಿತಿಯನ್ನು ಪ್ರಕಟಿಸಬಹುದು ಅಥವಾ ಸಾಮಾನ್ಯವಾಗಿ ಲಭ್ಯವಾಗಿಸಬಹುದು. ನಾವು ಸೇವೆಗಳ ಮೂಲಕ, ಕುಕೀಗಳ ಮೂಲಕ ಮತ್ತು ಈ ಗোপনীযತা ನಿಯಮಕತೆಯಲ್ಲಿ ವಿವರಿಸಿರುವ ಇತರ ಮಾರ್ಗಗಳ ಮೂಲಕ ಸಂಯೋಜಿತ ಮಾಹಿತಿಯನ್ನು ಸಂಗ್ರಹಿಸಬಹುದು. ನಾವು ವಿಶೇಷಣ-ಅಪಸ್ಥಿತ ಮಾಹಿತಿಯನ್ನು ಅನಾಮ್ಯ ಅಥವಾ ವಿಶೇಷಣ-ಅಪಸ್ಥಿತ ರೂಪದಲ್ಲಿ ನಿರ್ವಹಿಸುತ್ತೇವೆ ಮತ್ತು ಬಳಸುತ್ತೇವೆ, ಮತ್ತು ಕಾನೂನಿನಿಂದ ಕೋರಲ್ಪಡುವதಿ ಹೊರತು ನಾವು ಅಂತಹ ಮಾಹಿತಿಯನ್ನು ಪುನಃಗುರುತಿಸ முயற்சിക്കುವುದಿಲ್ಲ.',
    block7:
      'ಕೆಲವು ಸಂದರ್ಭಗಳಲ್ಲಿ, ಕಾನೂನಿನಿಂದ ಅಗತ್ಯವಾದರೆ, ನಾವು ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ನಿಮಗೆ ಮತ್ತಷ್ಟು அறிவಿ δίνονταιದೆ ಮೂರನೇ ಪಕ್ಷಗಳಿಗೆ ಒದಗಿಸಬಹುದು:',
    block8:
      'ನಿಮ್ಮ ಭೌಗೋಳಿಕ ಸ್ಥಳದ ಆಧಾರದ ಮೇಲೆ, ಯುರೋಪಿಯನ್ ეკನಾಮಿಕ್ ಏರಿಯಾ, ಯುನೈಟೆಡ್ ಕಿಂಗ್ಡಮ್ ಮತ್ತು ವಿಶ್ವದ ವ್ಯಾಪಕವಾಗಿ ವ್ಯಕ್ತಿಗಳಿಗೆ ತಮ್ಮ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಗೆ ಸಂಬಂಧಿಸಿದ ಕೆಲವು ಕಾನೋನಿ ಹಕ್ಕುಗಳು ಇರಬಹುದು. ಉದಾಹರಣೆಗೆ, ನಿಮ್ಮ ಹಕ್ಕುಗಳು ಇವು ಇರಬಹುದು:',
    block9:
      'ಈ ಸೇವೆಯಲ್ಲಿ ನೋಮ್ ಆಡಳಿಸದ ಅಥವಾ ನಿಯಂತ್ರಿಸದ ಇತರ ವೆಬ್ಸೈಟ್ಗಳಿಗೆ ಲಿಂಕ್ಗಳಿವೆ ಇರಬಹುದು, ಸಾಮಾಜಿಕ ಮಾಧ್ಯಮ ಸೇವೆಗಳನ್ನು ಸೇರಿದಂತೆ ("ತೃತীয ಪಕ್ಷ ವೆಬ್ಸೈಟ್ಗಳು"). ತೃತীয ಪಕ್ಷ ವೆಬ್ಸೈಟ್ಗಳೊಂದಿಗೆ ನೀವು ಹಂಚುವ ಮಾಹಿತಿ ಈ ಗোপনীযತೆ ನೀತಿಯಿಂದ ಅಲ್ಲ, ಬದಲಿಗೆ ತೃತীয ಪಕ್ಷ ವೆಬ್ಸೈಟ್ಗಳির ವಿಶೇಷ ಗোপনীযತೆ ನೀತಿಗಳು ಮತ್ತು ಸೇವೆ ನಿಯಮಗಳಿಂದ ನಿಯಂತ್ರಿಸಲ್ಪಡುತ್ತದೆ. ನಾವು ಈ ಲಿಂಕ್ಗಳನ್ನು ಸುಲಭತೆಗಾಗಿ ಒದಗಿಸುತ್ತೇವೆ ಮತ್ತು ಈ ವೆಬ್ಸೈಟ್ಗಳಿಗೆ ನಮ್ಮ ಅംഗೀಕರಣ ಅಥವಾ ವಿಮರ್ಶೆಯನ್ನು ಸೂಚಿಸುವುದಿಲ್ಲ. ಅವರ ಗোপনীযತೆ ನೀತಿಗಳು ಮತ್ತು ನಿಯಮಗಳಿಗೆ ಸಂಬಂಧಿಸಿದ ಮಾಹಿತಿಗಾಗಿ ತಕ್ಷಣವೇ ತೃತীয ಪಕ್ಷ ವೆಬ್ಸೈಟ್ಗಳೊಂದಿಗೆ ಸಂಪರ್ಕಿಸಿ.',
    subBlock1:
      'ಖಾತೆ ಮಾಹಿತಿ: ನೀವು ನಮ್ಮ ಪ್ಲಾಟ್ಫಾರ್ಮದಲ್ಲಿ ಖಾತೆ ರಚಿಸಿದಾಗ, ನಾವು ನಿಮ್ಮ ಖಾತೆಗೆ ಸಂಬಂಧಿಸಿದ ಮಾಹಿತಿಯನ್ನು ಸಂಗ್ರಹಿಸುತ್ತೇವೆ, ಸಹ ನಿಮ್ಮ ಹೆಸರು, ಸಂಪರ್ಕ ಮಾಹಿತಿ, ಖಾತೆ ರುಜುವಾತುಗಳು, ಪೇಮೆಂಟ್ ಕಾರ್ಡ್ ಮಾಹಿತಿ ಮತ್ತು ಲావాదಾರಿ ಇತಿಹಾಸ ("ಖಾತೆ ಮಾಹಿತಿ").',
    subBlock10: 'ಸೇವೆಗಳನ್ನು ಒದಗಿಸುವುದು, ನಿರ್ವಹಿಸುವುದು, பராமರಿಸುವುದು ಮತ್ತು/ಅಥವಾ ವಿಶ್ಲೇಷಿಸುವುದು;',
    subBlock11: 'ನಿಮ್ಮೊಂದಿಗೆ ಸಂವಾದಿಸುವುದು',
    subBlock12: 'ನವೀನ ಸಾಮಗ್ರಿಗಳು ಮತ್ತು ಸೇವೆಗಳನ್ನು ಅಭಿವೃದ್ಧಿಪಡಿಸುವುದು;',
    subBlock13:
      'ಶೋಧನೆ, ಅಪರಾಧ ಚಟುವಟಿಕೆ ಅಥವಾ ನಮ್ಮ ಸೇವೆಗಳನ್ನು ತಪ್ಪಾಗಿ ಬಳಸುವುದನ್ನು ತಡೆಗಟ್ಟುವುದು ಮತ್ತು ನಮ್ಮ IT ವ್ಯವಸ್ಥೆಗಳು, ವಾಸ್ತುಶಿಲ್ಪ ಮತ್ತು ನೆಟ್ವರ್ಕ್ಗಳുടെ ಸುರಕ್ಷತೆಯನ್ನು ರಕ್ಷಿಸುವುದು;',
    subBlock14: 'ವ್ಯಾಪಾರ ವರ್ಗಾವಣೆಗಳನ್ನು ಸঞ্চালಿಸುವುದು;',
    subBlock15:
      'ಕಾನೂನುಬದ್ಧತೆಗಳು ಮತ್ತು ಕಾನೂನು ಪ್ರಕ್ರಿಯೆಗಳಿಗೆ ಪಾಲಿಸುವುದು, ನಮ್ಮ ಹಕ್ಕುಗಳು, ಗೌಪ್ಯತೆ, ಸುರಕ್ಷತೆ ಅಥವಾ ಆಸ್ತಿಯನ್ನು ರಕ್ಷಿಸುವುದು, ಹಾಗೆಯೇ ನಮ್ಮ ಸಂಬಂಧಿತ ಸಂಸ್ಥೆಗಳು, ನಿಮ್ಮ ಅಥವಾ ಇತರ ಮೂರನೇ ಪಕ್ಷಗಳ ಆಸ್ತಿಯನ್ನು ರಕ್ಷಿಸುವುದು. ',
    subBlock16:
      'ಸಪ್ಲાયರ್ಗಳು ಮತ್ತು ಸೇವಾ ಪ್ರদಾನकर್ತાઓ: ವ್ಯಾಪಾರ ಕಾರ್ಯಾಶ್ರಯ ಅಗತಿಗಳನ್ನು ಪೂರೈಸಲು ಮತ್ತು ಕೆಲವು ಸೇವೆಗಳು ಮತ್ತು ಕ್ರಿಯೆಗಳನ್ನು ಪಡೆಯುವುದಕ್ಕೆ ನಮಗೆ ಸಹಾಯ ಮಾಡಲು, ನಾವು ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ಸಪ್ಲાયರ್ಗಳು ಮತ್ತು ಸೇವಾ ಪ್ರদಾನकर್ತાઓక್ಕೆ ಒದಗಿಸಬಹುದು, ಇದರಲ್ಲಿ ಹೋಸ್ಟಿಂಗ್ ಸೇವಾ ಪ್ರদಾನकर್ತાઓ, ಕ್ಲೌಡ್ ಸೇವಾ ಪ್ರదಾನकर್ತાઓ, ಮತ್ತು ಇತರ ಆನೆತ್ ತکنಾಲಜಿ ಸೇವಾ ಪ್ರదಾನकर್ತાઓ, ಇಮೇಲ್ ಸಂವಹನ ಸಾಫ್ಟ್ವೇರ್ ಮತ್ತು ವೆಬ್ ಅನಾಲಿಟಿಕ್ಸ್ ಸೇವಾ ಪ್ರదಾನकर್ತાઓ ইತ್ಯಾದಿ ಸೇರಿವೆ. ಈ ಪಾಲುದಾರರು ನಮ್ಮ ಸೇವೆಗಳನ್ನು ನಿರ್ವಹಿಸುವಾಗ ನಮ್ಮ ಆದೇಶದ ಮತ್ತು ಮಾತ್ರ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ಪ್ರವೇಶಿಸে, ಪ್ರಕ್ರಿಯೆ ಮಾಡಿ ಅಥವಾ ಸಂಗ್ರಹಿಸುತ್ತಾರೆ.',
    subBlock17:
      'ವ್ಯಾಪಾರ ವರ್ಗಾವಣೆಗಳು: ನಾವು ತಕ್ಷಣಾತ್ಮಕ ವ್ಯಾಪಾರಗಳು, ಪುನರ್ನಿರ್ಮಾಣಗಳು, ದिवಾಲ್ಲತೆ, ದिवಾಲ್ಲತೆ ಪಡೆಯುವಿಕೆಗಳು ಅಥವಾ ಸೇವೆಗಳನ್ನು ಇನ್ನೊಂದು ಪ್ರদಾನಕಕ್ಕೆ ಸ್ಥಳಾಂತರಿಸಿದರೆ (ಒಟ್ಟಿಗೆ "ವ್ಯಾಪಾರಗಳು"), ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿ ಮತ್ತು ಇತರ ಮಾಹಿತಿಯನ್ನು ವ್ಯಾಪಾರದ ಪಕ್ಷಗಳು ಮತ್ತು ವ್ಯಾಪಾರಗಳನ್ನು ಸಹಾಯ ಮಾಡುವ ಇತರ ಪಕ್ಷಗಳೊಂದಿಗೆ ಡ್ಯೂ ಡಿಲಿಜೆನ್ಸ್ ಸಮಯದಲ್ಲಿ ಹಂಚಬಹುದು ಮತ್ತು ಇತರ ಆಸ್ತಿಗಳೊಂದಿಗೆ ವ್ಯಾಪಾರದ ಭಾಗವಾಗಿ ಆತಿಯೋಜಕ ಅಥವಾ ಸಂಬಂಧಿತ ಕಂಪನಿಗೆ ವರ್ಗಾವಣೆ ಮಾಡಬಹುದು. ',
    subBlock18:
      'ಕಾನೂನಿ ಅಪೇಕ್ಷೆಗಳು: ನಿಮ್ಮ ವ്യക್ತಿ ಮಾಹಿತಿಯನ್ನು ಸರ್ಕಾರಿ ಅಧಿಕಾರಿಗಳು, ಕೈಗಾರಿಕೆ ಸ್ನೇಹಿತರು ಅಥವಾ ಇತರ ತ್ರಿ-ಪಕ್ಷಗಳೊಂದಿಗೆ ಹಂಚಬಹುದು, ನಮ್ಮ ಸೇವೆಗಳೊಂದಿಗಿನ ನಿಮ್ಮ ಸಂವಹನ ಮಾಹಿತಿ ಸೇರಿದಂತೆ, (1) ಕಾನೂನಿನಿಂದ ಅಪೇಕ್ಷಿಸಲಾದಿದ್ದರೆ ಅಥವಾ ಕಾನೂನಿನ ಕನಿಷ್ಠಾವसरಗಳನ್ನು ಪಾಲಿಸುವುದಕ್ಕೆ આવ,such ಕ್ರಿಯೆ ಅಗತ್ಯವಿದೆ ಎಂದು ನಾವು ನಂಬಿದರೆ; (2) ನಮ್ಮ ಹಕ್ಕುಗಳ ಅಥವಾ ಸ್ವತ್ತುಗಳನ್ನು ರಕ್ಷಿಸಲು ಮತ್ತು ರಕ್ಷಿಸಲು; (3) ನಮ್ಮ ನಿಯಮಗಳು, ನೀತಿಗಳು ಅಥವಾ ಕಾನೂನಿಗಳಲ್ಲಿ ಉಲ್ಲಂಘನೆ ಇದೆ ಎಂದು ನಾವು ಏಕಪಕ್ಷೀಯವಾಗಿ ನಿರ್ಧರಿಸಿದರೆ; (4) ವಂಚನೆ ಅಥವಾ ಇತರ ಅಕ್ರಮ ಕ್ರಿಯೆಗಳನ್ನು ಪತ್ತೆ ಹುಡುಕಲು ಅಥವಾ ತಡೆಗಟ್ಟಲು; (5) ನಮ್ಮ ಉತ್ಪನ್ನಗಳು, ಸಂಪನ್ಮೂಲಗಳು ಅಥವಾ ಬಳಕೆದಾರರು, ಅಥವಾ ಸಾರ್ವಜನಿಕ ಸುರಕ್ಷೆ, ಸುರಕ್ಷೆ, ಸಂಪೂರ್ಣತೆಯನ್ನು ರಕ್ಷಿಸಲು; ಅಥವಾ (vi) ಕಾನೂನಿನ LIABILITY ವನ್ನು ವೇದನೆ ಮಾಡಲು.',
    subBlock19:
      'ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿ ಮತ್ತು ಅದು ಹೇಗೆ ಪ್ರಕ್ರಿಯೆ ಮಾಡಲಾಗುತ್ತದೆ ಎಂಬ ಮಾಹಿತಿಯನ್ನು ಪ್ರವೇಶಿಸಿ.',
    subBlock2:
      'ನೀವು ನಮ್ಮ ಸೇವೆಗಳನ್ನು ಬಳಸಿದಾಗ, ನಿಮ್ಮ ಇನ್ಪುಟ್ಗಳು, ಫೈಲ್ ಅಪ್ಲೋಡ್ಗಳು ಅಥವಾ ನಮಗೆ ಒದಗಿಸಿದ ಪ್ರತಿಕ್ರಿಯೆಗಳಿಂದ ("ಕಂಟೆಂಟ್") ನಾವು ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ಸಂಗ್ರಹಿಸುತ್ತೇವೆ.',
    subBlock20:
      'ನಮ್ಮ பதிவுகளிலிருந்து ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ಅಳಿಸಿ ಅಳಿಸುವಂತೆ ವಿನಂತಿ ಮಾಡುತ್ತೇವೆ.',
    subBlock21: 'ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ಸರಿಪಡಿಸಿ ಅಥವಾ ಅಪ್ಡೇಟ್ ಮಾಡಿ.',
    subBlock22: 'ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ಮೂರನೇ ಪಕ್ಷಕ್ಕೆ ವರ್ಗಾಯಿಸಿ (ಡೇಟಾ ಪೋರ್ಟಬಿಲಿಟಿ).',
    subBlock23: 'ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ನಾವು ಹೇಗೆ ಪ್ರಕ್ರಿಯೆ ಮಾಡುತ್ತೇವೆ તેને ಸೀಮಿತ ಮಾಡಿ.',
    subBlock24:
      'ನಿಮ್ಮ ಒಪ್ಪಿಗೆಯನ್ನು ಹಿಂತೆಗೆ ಹರಿಸಿ—ಇಲ್ಲಿ ನಾವು ಪ್ರಕ್ರಿಯೆಗಾಗಿ ಕಾನೂನಿ ಆಧಾರವಾಗಿ ಒಪ್ಪಿಗೆಯನ್ನು ಅವಲಂಬಿಸುತ್ತೇವೆ, ನೀವು ಯಾವುದೇ ಸಮಯದಲ್ಲಿ ನಿಮ್ಮ ಒಪ್ಪಿಗೆಯನ್ನು ಹಿಂತೆಗೆ ಹರಿಸಬಹುದು. ',
    subBlock25: 'ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ನಾವು ಹೇಗೆ ಪ್ರಕ್ರಿಯೆ ಮಾಡುತ್ತೇವೆ ಎಂಬುದಕ್ಕೆ ವಿರೋಧಿಸಿ.',
    subBlock26: 'ನಮ್ಮ ಸೇವೆಗಳನ್ನು ಸುಧಾರಿಸುವುದು ಮತ್ತು ಸಂಶೋಧನೆ ನಡೆಸುವುದು;',
    subBlock3:
      'ಸಂವಹನ ಮಾಹಿತಿ: ನೀವು ನಮಗೆ ಸಂದೇಶಗಳನ್ನು ಕಳುಹಿದರೆ, ನಿಮ್ಮ ಹೆಸರು, ಸಂಪರ್ಕ ಮಾಹಿತಿ ಮತ್ತು ನಿಮ್ಮ ಸಂದೇಶಗಳ ವಿಷಯವನ್ನು ನಾವು ಸಂಗ್ರಹಿಸುತ್ತೇವೆ ("ಸಂವಹನ ಮಾಹಿತಿ").',
    subBlock4:
      'ಸೋಷ್ಯಲ್ ಮೀಡಿಯಾ ಮಾಹಿತಿ: ಇನ್ಸ್ಟಾಗ್ರಾಮ್, ಫೇಸ್ಬುಕ್, ಮೀಡಿಯಮ್, ಟ್ವಿಟರ್, ಯೂಟ್ಯೂಬ್ ಮತ್ತು ಲಿಂಕೆಡ್ಇನ್ ಸಂತ್ರಸ್ಥ ಸೋಷ್ಯಲ್ ಮೀಡಿಯಾ ವೆಬ್ಸೈಟ್ಗಳ પર ನಮ್ಮ ಪುಟಗಳಿವೆ. ನಮ್ಮ ಸೋಷ್ಯಲ್ ಮೀಡಿಯಾ ಪುಟಗಳೊಂದಿಗೆ ನೀವು ಸಂವಹಿಸಿದಾಗ, ನಿಮ್ಮ ಸಂಪರ್ಕ ವಿವರಗಳು ಸಂತ್ರಸ್ಥ ನಿಮ್ಮು ನಮಗೆ ಒದಗಿಸಲು ಆಯ್ಕೆ ಮಾಡಿದ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ನಾವು ಸಂಗ್ರಹಿಸುತ್ತೇವೆ ("ಸೋಷ್ಯಲ್ ಮಾಹಿತಿ"). ಹೆಚ್ಚುವರಿ olarak, ನಮ್ಮ ಸೋಷ್ಯಲ್ ಮೀಡಿಯಾ ಪುಟಗಳನ್ನು ಹೋಸ್ಟ್ ಮಾಡುವ ಕಂಪನಿಗಳು ನಮ್ಮ ಸೋಷ್ಯಲ್ ಮೀಡಿಯಾ ಚಟುವಟಿಕೆಗಳ ಬಗ್ಗೆ ಸಂಯೋಜಿತ ಮಾಹಿತಿ ಮತ್ತು ವಿಶ್ಲೇಷಣೆಯನ್ನು ನಮಗೆ ಒದಗಿಸಬಹುದು. ',
    subBlock5:
      'ಲಾಗ್ ಡೇಟಾ: ನಮ್ಮ ಸೇವೆಗಳನ್ನು ಬಳಸಿದಾಗ ನಿಮ್ಮ ಬ್ರೌಸರ್ ಆಟೋಮ್ಯಾಟಿಕ್ ಮಾಡಿ ಕಳುಹಿಸುವ ಮಾಹಿತಿ. ಲಾಗ್ ಡೇಟಾದಲ್ಲಿ ನಿಮ್ಮ ಇಂಟರ್ನೆಟ್ ಪ್ರೋಟೋಕಾಲ್ (ಐಪಿ) ವಿಡ್ಡ್ರೆಸ್, ಬ್ರೌಸರ್ ಪ್ರಕಾರ ಮತ್ತು ಸೆಟ್ಟಿಂಗ್ಗಳು, ನಿಮ್ಮ ವಿನಂತಿಗಳ ದಿನಾಂಕ ಮತ್ತು ಸಮಯ, ಮತ್ತು ನೀವು ನಮ್ಮ ವೆಬ್ಸೈಟ్‌తో ಹೇಗೆ ಸಂವಾದಿಸುತ್ತೀರಿ ಎಂಬುದನ್ನು ಸೇರಿದೆ. ',
    subBlock6:
      'ಬಳಕೆ ಡೇಟಾ: ನಿಮ್ಮ ಸೇವೆಯ ಬಳಕೆಯ ಬಗ್ಗೆ ನಾವು ಸ್ವಯಂಚಾಲಿತವಾಗಿ ಮಾಹಿತಿ ಸಂಗ್ರಹಿಸಬಹುದು, ಉದಾಹರಣೆಗೆ ನೀವು ವೀಕ್ಷಿಸುವ ಅಥವಾ ಸಂವಹನ ಮಾಡುವ ವಿಷಯದ ಪ್ರಕಾರಗಳು, ನೀವು ಬಳಸುವ ವಿಶೇಷಣಗಳು, ನೀವು ಮಾಡುವ ಕ್ರಿಯೆಗಳು, ಹಾಗೆಯೇ ನಿಮ್ಮ ಸಮಯ மண்டಲం, ದೇಶ, ಪ್ರವೇಶದ ದಿನಾಂಕ ಮತ್ತು ಸಮಯ, பயೋಜಕ ಏಜೆಂಟ್ ಮತ್ತು ಆವೃತ್ತಿ, ಕಂಪ್ಯೂಟರ್ ಅಥವಾ ಮೊಬೈಲ್ ಸಾಧನ ಪ್ರಕಾರ ಮತ್ತು ನಿಮ್ಮ ಕಂಪ್ಯೂಟರ್ ಸಂಪರ್ಕವು.',
    subBlock7:
      'ಸಾಧನ ಮಾಹಿತಿ: ഇതು ಸಾಧನದ ಹೆಸರು, ಆಪರೇಷನ್ ಸಿಸ್ಟಮ್, ಸಾಧನ ಗುರುತಿಸುವಿಕೆ ಮತ್ತು ನೀವು ಬಳಸುತ್ತಿರುವ ಬ್ರೌಸರ್ ಅನ್ನು ಒಳಗೊಂಡಿದೆ. ಸಂಗ್ರಹಿಸಲಾದ ಮಾಹಿತಿ ನೀವು ಬಳಸುತ್ತಿರುವ ಸಾಧನದ ಪ್ರಕಾರ ಮತ್ತು ಅದರ ಸೆಟ್ಟಿಂಗ್ಗಳပေါ် မူတညಿರಬಹುದು. ',
    subBlock8:
      'ಕುಕೀಗಳು: ನಮ್ಮ ಸೇವೆಗಳನ್ನು ಕಾರ್ಯನಿರ್ವಹಿಸಲು ಮತ್ತು ನಿರ್ವಹಿಸಲು ಮತ್ತು ನಿಮ್ಮ ಅನುಭವವನ್ನು ಸುಧಾರಿಸಲು ನಾವು ಕುಕೀಗಳನ್ನು ಬಳಸುತ್ತೇವೆ. "ಕುಕಿ" ಎನ್ನುವುದು ನೀವು ಭ್ರವಿಸುವ ವೆಬ್ಸೈಟ್ ನಿಂದ ನಿಮ್ಮ ಬ್ರೌಸರ್ ಗೆ ಕಳುಹಿಸುವ ಮಾಹಿತಿ ஆகும். ನೀವು ಎಲ್ಲಾ ಕುಕೀಗಳನ್ನು ಸ್ವೀಕರಿಸಲು, ಎಲ್ಲಾ ಕುಕೀಗಳನ್ನು ತಿರಸ್ಕರಿಸಲು ಅಥವಾ ಕುಕಿ ಒದಗಿಸಲಾಗಿದ್ದಾಗಿ ನಿಮಗೆ ಸೂಚಿಸಲು ಬ್ರೌಸರ್ ಅನ್ನು ಸೆಟ್ ಮಾಡலாம், ಇದರಿಂದ ನೀವು ಪ್ರತಿ ಬಾರಿ ಸ್ವೀಕರಿಸಬೇಕೆ ಅಥವಾ ತಿರಸ್ಕರಿಸಬೇಕೆ ಎಂಬುದನ್ನು ನಿರ್ಧರಿಸಬಹುದು. ಆದಾಗ್ಯೂ, ಕುಕೀಗಳನ್ನು ತಿರಸ್ಕರಿಸುವುದು ವೆಬ್ಸೈಟ್ನ某些 ಕ್ಷೇತ್ರಗಳು ಅಥವಾ ವಿಶೇಷತೆಗಳನ್ನು ಬಳಸುವುದನ್ನು ತಡೆಯಬಹುದು ಅಥವಾ ಪ್ರದರ್ಶನ ಅಥವಾ ಕ್ರಿಯಾತ್ಮಕತೆಯನ್ನು ಕೆಟ್ಟದ್ದು ಮಾಡಬಹುದು. ಕುಕೀಗಳ ಬಗ್ಗೆ ಹೆಚ್ಚಿನ ಮಾಹಿತಿಗಾಗಿ, ದಯವಿಟ್ಟು "ಎಲ್ ಅಬೌಟ್ ಕುಕೀಸ್" ವೆಬ್ಸೈಟ್ ಅನ್ನು ಭ್ರವಿಸಿ.',
    subBlock9:
      'ಅನಲിറ್ಟಿಕ್ಸ್: ನಾವು ವಿವಿಧ ಆನ್ಲೈನ್ ანಲിറ್ಟಿಕ್ಸ್ ಪ್ರೋಡಕ್ಟ್ಗಳನ್ನು ಬಳಸಬಹುದು, ಅವು ಕುಕೀಗಳನ್ನು ಬಳಸುತ್ತವೆ ಮತ್ತು ಬಳಕೆದಾರರು ನಮ್ಮ ಸೇವೆಗಳನ್ನು ಹೇಗೆ ಬಳಸುತ್ತಾರೆ ಎಂಬುದನ್ನು ವಿಶ್ಲೇಷಿಸಲು ಮತ್ತು ಸೇವೆಗಳನ್ನು ಬಳಸುವಾಗಿ ನಿಮ್ಮ ಅನುಭವವನ್ನು ಸುಧಾರಿಸಲು ನಮಗೆ ಸಹಾಯ ಮಾಡುತ್ತವೆ.',
    subTitle1: 'ನಾವು ಸಂಗ್ರಹಿಸುವ ವ്യക್ತಿ ಮಾಹಿತಿ',
    subTitle2: 'ನಾವು ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ಹೇಗೆ ಬಳಸುತ್ತೇವೆ',
    subTitle3: 'ವೈಯಕ್ತಿಕ ಮಾಹಿತીન ಪ್ರಕಟನೆ',
    subTitle4: 'ನಿಮ್ಮ ಹಕ್ಕುಗಳು',
    subTitle5: 'ಇತರ ವೆಬ್ಸೈಟ್ಗಳಿಗೆ ಲಿಂಕ್',
    subTitle6: 'ಮಾಹಿತીની ಸುರಕ್ಷತೆ ಮತ್ತು ಸಂರಕ್ಷಣೆ',
    subTitle7: 'ಗোপনತ್ವ ನಿಯಮದ ಮಾರ್ಪಣೆ',
    subTitle8: 'ನಮ್ಮನ್ನು ಹೇಗೆ ಸಂಪರ್ಕಿಸುವುದು',
    title: 'ಗೌಪ್ಯತಾ ನಿಯಮಗಳು',
    updateTime: 'ಅಪ್ಡೇಟೆಡ್: ಮಾರ್ಚ್ 15, 2024',
  },
  privacyCollectionPanel: {
    acceptBtn: 'ಎಲ್ಲವನ್ನು ಅಂಗೀಕರಿಸಿ',
    text: 'ನಿಮ್ಮ ಅನುಭವವನ್ನು ಸುಧಾರಿಸಲು, ನಾವು ವಿಷಯ ಮತ್ತು ಸೇವೆಗಳನ್ನು ವೈಯಕ್ತಿಕಗೊಳಿಸಲು ಕುಕೀಗಳನ್ನು ಬಳಸುತ್ತೇವೆ.',
    title: 'ಈ ವೆಬ್ಸೈಟ್ ಕುಕೀಗಳನ್ನು ಬಳಸುತ್ತದೆ',
  },
  slogen: 'ಎತ್ಯಂತ ಸುಲಭವಾದ AI ಅಸಿಸ್ಟೆಂಟ್',
  stripe: {
    contact: 'ಯಾವುದೇ ಪ್ರಶ್ನೆಗಳಿಗೆ contact@noam.tools ನಲ್ಲಿ ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ!',
    fail: {
      btn: 'ಮళ్లಿ ಪ್ರಯತ್ನಿಸಿ',
      text1: 'ನಿಮ್ಮ ಪೇಮೆಂಟ್ ಪ್ರಕ್ರಿಯೆ ಮಾಡಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ.',
      text2: 'ನಿಮ್ಮ ಕನೆಕ್ಷನ್ ಅನ್ನು ಪರಿಶೀಲಿಸಿ ಮತ್ತು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
      title: 'ಪೇಮೆಂಟ್ ವಿಫಲವಾಗಿದೆ',
    },
    succ: {
      btn: 'ತಯಾರಾಗಿ ಹೋಣಿ',
      text1: 'ನೋಮ್ಗೆ ಸ್ವಾಗತം',
      text2: 'ಈಗ ಪ್ರಾರಂಭಿಸೋಣ!',
      title: 'ಅಭಿನಂದನೆಗಳು',
    },
  },
  terms: {
    block1: 'ನೋಮ್ ಅನ್ನು ಬಳಸಿದ್ದಕ್ಕೆ ಧನ್ಯವಾದಗಳು!',
    block10:
      '(a) ಶುಲ್ಕ ಮತ್ತು ಬಿಲ್ಲಿಂಗ್. ಅನ್ವಯೋಯಿತ ಪ್ರೈಸಿಂಗ್ ಪೇಜಿನಲ್ಲಿನ ಬೆಲೆ ಮತ್ತು ಪದಕ್ಕೆ ಅಥವಾ ನಮ್ಮ இடையೆ ಲೇಖನಕ್ಕೆ ಒಪ್ಪಂದ ಮಾಡಿದಂತೆ ನೀವು ಎಲ್ಲ ಶುಲ್ಕಗಳನ್ನು ("ಶುಲ್ಕಗಳು") ಪಾವತಿಸುತ್ತೀರಿ. ನಾವು ಇನ್ವಾಯ್ಸ್ ಪ್ರಕಟಿಸಿದ್ದರೂ ಅಥವಾ ಪಾವತಿ ಸ್ವೀಕರಿಸಿದ್ದರೂ ಸಹ ಬೆಲೆ ತಪ್ಪುಗಳನ್ನು ಅಥವಾ ತಪ್ಪುಗಳನ್ನು ಸರಿಪಡಿಸುವ ಹಕ್ಕನ್ನು ಕಾಯ giữುತ್ತೇವೆ. ನೀವು ಸಂಪೂರ್ಣ ಮತ್ತು ನಿಖರವಾದ ಬಿಲ್ಲಿಂಗ್ ಮಾಹಿತಿಯನ್ನು ಒದಗಿಸುತ್ತೀರಿ, ಇದು ಮಾನ್ಯ ಮತ್ತು ಅಧಿಕೃತ ಪಾವತಿ ವಿಧಾನವನ್ನು ಒಳಗೊಂಡಿದೆ. ಒಪ್ಪಂದ ಮಾಡಿದಂತೆ ನಾವು ನಿಮ್ಮ ಪಾವತಿ ವಿಧಾನವನ್ನು ಪერಿಯೋಡಿಕ್ ಆಧಾರದ ಮೇಲೆ ಚಾರ್ಜ್ ಮಾಡುತ್ತೇವೆ, ಆದರೆ ನಾವು ಬಿಲ್ಲಿಂಗ್ ದಿನಾಂಕವನ್ನು ಸಮಂಜಸವಾಗಿ ಬದಲಾಯಿಸಬಹುದು. ನೀವು ನೋಮ್, ಅದರ ಸಂಬಂಧಿತ ಸಂಸ್ಥೆಗಳು ಮತ್ತು ಮೂರನೇ ಪಕ್ಷ ಪಾವತಿ ಪ್ರೊಸೆಸರ್ಗಳಿಗೆ ನಿಮ್ಮ ಪಾವತಿ ವಿಧಾನವನ್ನು ಚಾರ್ಜ್ ಮಾಡಲು ಅಧಿಕಾರ ನೀಡುತ್ತೀರಿ. ನಿಮ್ಮ ಪಾವತಿ ವಿಫಲವಾದರೆ, ನಾವು ನಿಮಗೆ ಲೇಖನದ ಮೂಲಕ ನೋಟವನ್ನು ಒದಗಿಸುತ್ತೇವೆ ಮತ್ತು ಪಾವತಿ ಸ್ವೀಕರಿಸುವವರೆಗೆ ಸೇವೆಗೆ ಪ್ರವೇಶವನ್ನು ನಿಷ್ಕ್ರಿಯಗೊಳಿಸಬಹುದು. ಈ ಒಪ್ಪಂದದಲ್ಲಿ ಬೇರೆ ರೀತಿ ವಿಶೇಷವಾಗಿ ವಿಶೇಷಿಸಿ ಹೊಂದಿಲ್ಲದಿದ್ದರೆ, ಪಾವತಿಗಳು ಮರುಪಡೆಯಾಗುವುದಿಲ್ಲ.',
    block11:
      '(ಬಿ) ತಯಾರಗಳು. ಇನ್ನೆ ಹೆಚ್ಚಿನ ವಿವರಣೆ ಇಲ್ಲದಿದ್ದರೆ, ಶುಲ್ಕಗಳು ಯಾವುದೇ ಕೇಂದ್ರ, ರಾಜ್ಯ, ಸ್ಥಳೀಯ ಮತ್ತು ವಿದೇಶಿ ತಯಾರಗಳು, duteಿ ಮತ್ತು ಹೋಲಿಕೆ ಮೌಲ್ಯಮಾಪನಗಳನ್ನು ("ತಯಾರಗಳು") ಒಳಗೊಂಡಿರುವುದಿಲ್ಲ. ನಿಮ್ಮ ಖರೀದಿಗಳಿಗೆ ಸಂಬಂಧಿಸಿದ ಎಲ್ಲಾ ತಯಾರಗಳಿಗೆ ನೀವು ಜವಾಬ್ದಾರಿಯಾಗಿದ್ದೀರಿ, ನಮ್ಮ ನಿವ್ವಳ ಆದಾಯವನ್ನು ಆಧರಿಸಿ ನಾವು ನಿಮಗೆ ಇನ್ವಾಯಿಸುವ ತಯಾರಗಳನ್ನು ಹೊರತುಪಡಿಸಿ ಹೊರತುಪಡಿಸಿ ಹೊರತುಪಡಿಸಿ. ನೀವು ಅಂತ್ಯ ತಯಾರಗಳನ್ನು ತಕ್ಷಣವಾಗಿ ಪಾವತಿಸಿ ಮತ್ತು ನಮಗೆ ಕಾನೂನಿ ವಿಶೇಷವಾಗಿ ಮಾನ್ಯ ಗೌಪ್ಯತා ಹೇಳಿಕೆಗಳನ್ನು ಒದಗಿಸಿ ಮತ್ತು ಅಂತ್ಯ ಡೇಟಾವನ್ನು ಸಂಪ黎雨ಿಸಲು ಅಗತ್ಯ ಒಪ್ಪಿಗೆಗಳನ್ನು ಪಡೆಯುತ್ತೀರಿ ಎಂದು ಒಪ್ಪಿಕೊಳ್ಳುತ್ತೀರಿ, ಮತ್ತು ನೀವು ಅಂತ್ಯ ಡೇಟಾವನ್ನು ಅನ್ವಯೋಜ್ಯ ಕಾನೂನಿಗೆ ಅನುಸರಿಸಿ ಸಂಪ黎雨ಿಸುತ್ತೀರಿ ಎಂದು ನಮಗೆ ವಾರಂತಿಸುತ್ತೀರಿ.',
    block12:
      '(ಸಿ) ಬೆಲೆ ಬದಲಾವಣೆಗಳು. ನಿಮ್ಮ ಖಾತೆ ಮತ್ತು/ಅಥವಾ ನಮ್ಮ ವೆಬ್ಸೈಟ್ ಮೂಲಕ ನಿಮಗೆ ಸೂಚಿಸುವ ಮೂಲಕ ನಾವು ನಮ್ಮ ಬೆಲೆಗಳನ್ನು ಬದಲಾಯಿಸಬಹುದು. ಬೆಲೆ ಹೆಚ್ಚಳಗಳು ಪೋಸ್ಟ್ ಮಾಡಿದ ನಂತರ ತಕ್ಷಣವೇ ಪ್ರಯೋಜನಕಾರಿ ಆಗುತ್ತವೆ. ಬದಲಾವಣೆಯ ಪ್ರಯೋಜನಕಾರಿ ದಿನಾಂಕದ ನಂತರ ನಿಮ್ಮ ಖಾತೆಗಾಗಿ ಶುಲ್ಕಗಳಿಗೆ ಯಾವುದೇ ಬೆಲೆ ಬದಲಾವಣೆಗಳು ಅನ್ವಯವಾಗುತ್ತವೆ.',
    block13:
      '(d) ವಿವಾದಗಳು ಮತ್ತು ತ ಮಾಡದ ಪಾವತಿಗಳು. ಯಾವುದೇ ಶುಲ್ಕಗಳು ಅಥವಾ ತಯಾರಿಗಳನ್ನು ವಿವಾದಿಸಿ ಬಯಸಿದರೆ, ಬಿಲ್ ದಿನಾಂಕದಿಂದ ಮുപ್ಪತ್ತು (30) ದಿನಗಳೊಳಗೆ contact@noam.tools ಗೆ ಸಂಪರ್ಕಿಸಿ.',
    block14:
      'ಶ್ರೀಮತಿ ಬಳಕೆ. ಮुफ್ತ ಕ್ರೆಡಿಟ್ ಪಡೆಯಲು ನೀವು ಹೆಚ್ಚಿನ ಅಕೌಂಟ್ಗಳನ್ನು ಸೃಷ್ಟಿಸಬಾರದು. ನಿಮ್ಮು ಮुफ್ತ ಕ್ರೆಡಿಟ್ ಅನ್ನು ನಿಷ್ಠೆಯಿಂದ ಬಳಸುತ್ತಿಲ್ಲ ಎಂದು ನಾವು ನಿರ್ಧರಿಸಿದರೆ, ನಾವು ನಿಮಗೆ ಸ್ಟ್ಯಾಂಡರ್ಡ್ ಶುಲ್ಕಗಳನ್ನು ವಸूलಿಸಬಹುದು ಅಥವಾ ಸೇವೆಗೆ ಪ್ರವೇಶವನ್ನು ನಿಲ್ಲಿಸಬಹುದು.',
    block15:
      'ರಕ್ಷಣಾತ್ಮಕತೆ. ನಿಮ್ಮ પાસે ನೋಮ್‌ನ ಗোপনীয ಸಂಪರ್ಕಿತ ಮಾಹಿತಿ ಪ್ರವೇಶವಿರಬಹುದು. ಸೇವೆಯನ್ನು ಬಳಸುವ ಉದ್ದೇಶಕ್ಕಾಗಿ ಈ ಪದಗಳಡಿಯಲ್ಲಿ ಅನುಮತಿ ನೀಡಲಾಗಿದೆಂತೆ ಮಾತ್ರ ನೀವು ಗोপনীয ಮಾಹಿತಿಯನ್ನು ಬಳಸಬಹುದು. ನೀವು ಗोপনীয ಮಾಹಿತಿಯನ್ನು ಯಾವುದೇ ತೃತীয় ಪಕ್ಷಕ್ಕೆ ಪ್ರಕಟಿಸಬಾರದು, ಮತ್ತು ನಿಮ್ಮ ಸ್ವಂತ ಒಂದೇ ರೀತಿಯ ಗोপনীয ಮಾಹಿತಿಯನ್ನು ರಕ್ಷಿಸುವಂತೆ ಹೆಚ್ಚಿನ ರಕ್ಷಣೆಯನ್ನು ನೀಡದೆ ಕನಿಷ್ಠವಾಗಿ ಸಮಂಜಸ್ಯದ ಪ್ರಯತ್ನದೊಂದಿಗೆ ಗोপনীয ಮಾಹಿತಿಯನ್ನು ರಕ್ಷಿಸುತ್ತೀರಿ. ಗೋপনীয ಮಾಹಿತಿ ಎನ್ನುವುದು ನೋಮ್ द्वारा ಗೋপনীয ಎಂದು ಗಳಿಸಿದ ಅಥವಾ ಸಂದರ್ಭಗಳಲ್ಲಿ ಸಮಂಜಸ್ಯವಾಗಿ ಗೋপনীযವಾಗಿ ವ್ಯಾಖ್ಯಾನிக்கப்படಬೇಕಾದ ಸಾರ್ವಜನಿಕವಲ್ಲದ ಮಾಹಿತಿ ஆகும், ಇದರಲ್ಲಿ ಸಾಫ್ಟ್ವೇರ್, ವಿಶೇಷಣಗಳು ಮತ್ತು ಇತರ ಸಾರ್ವಜನಿಕವಲ್ಲದ ವ್ಯಾಪಾರ ಮಾಹಿತಿ ಸೇರಿದೆ. ಗೋপনীয ಮಾಹಿತಿಯಲ್ಲಿ ಈ ಕೆಳಗಿನ ಮಾಹಿತಿ ಸೇರುವುದಿಲ್ಲ: (1) ನಿಮ್ಮ ಪಕ್ಷದ ಅಪರಾಧವಿಲ್ಲದೆ ಸಾಮಾನ್ಯವಾಗಿ ಸಾರ್ವಜನಿಕಕ್ಕೆ ಲಭ್ಯವಾಗುವುದು; (2) ಈ ಪದಗಳಡಿಯಲ್ಲಿ ಪಡೆಯುವ ಮೊದಲು ನೀವು ಗೋপনীযತೆಯ ಕೊಲ್ಪಡೆ ಇಲ್ಲದೆ ಸ್ವಂತ ಸ್ವಾಮ್ಯದಲ್ಲಿ ಹೊಂದಿದ್ದೀರಿ; (3) ಯಾವುದೇ ಗೋপনীযತೆ ಕೊಲ್ಪಡೆಗಳಿಲ್ಲದೆ ತೃತীয় ಪಕ್ಷದಿಂದ ನಿಮಗೆ ಕಾನೂನಿಯಾಗಿ ಪ್ರಕಟಿಸಲಾಗಿದೆ; ಅಥವಾ (4) ಗೋপনীয ಮಾಹಿತಿಯನ್ನು ಬಳಸದೆ ನೀವು ಸ್ವತಂತ್ರವಾಗಿ ವಿಕಸിപ്പിച്ചಿದೆ. ಕಾನೂನು, ನ್ಯಾಯಾಲಯ ಅಥವಾ ಇತರ ಸರ್ಕಾರಿ ಆದೇಶದಿಂದ ಕೋಶಿಷಿಸಿದರೆ ನೀವು ಗೋপনীয ಮಾಹಿತಿಯನ್ನು ಪ್ರಕಟಿಸಬಹುದು, ಆದರೆ ನೀವು ನೋಮ್ಗೆ ಸಮಂಜಸ್ಯದ ರೀತಿಯಲ್ಲಿ ಪೂರ್ವ ಲೇಖನಾತ್ಮಕ ಸೂಚನೆಯನ್ನು ನೀಡಬೇಕು ಮತ್ತು ಸಾಧ್ಯವಾದ ಮಟ್ಟಿಗೆ, ಪ್ರಕಟಣೆಯ ವ್ಯಾಪ್ತಿಯನ್ನು ಸೀಮಿತ કરવા ಸಮಂಜಸ್ಯದ ಪ್ರಯತ್ನಗಳನ್ನು ಮಾಡಬೇಕು, ಪ್ರಕಟಣೆ ವಿನಂತಿಗಳನ್ನು ವಿರೋಧಿಸುವಲ್ಲಿ ನಮ್ಮನ್ನು ಸಹಾಯ ಮಾಡುವುದು ಸೇರಿದೆ.',
    block16:
      '(ಬಿ) ಸುರಕ್ಷತೆ. ಸೇವೆಗಾಗಿ ನಿಮ್ಮ ಪ್ರವೇಶ ಮತ್ತು ಬಳಕೆಯನ್ನು ಸੁਰಕ್ಷित ಸುಧಾರಿಸಲು ನೀವು ಸಂಬಂಧಿಸಿದ ಮತ್ತು ಸೂಕ್ತ ಕ್ರಮಗಳನ್ನು ಜಾರಿಗೆ ತಯಾರಿಸಬೇಕು. ಸೇವೆಯ ಬಳಕೆಗೆ ಸಂಬಂಧಿಸಿದ ಯಾವುದೇ ವಿಶೇಷತೆಗಳು ಅಥವಾ ಉಲ್ಲಂಘನೆಗಳನ್ನು ನೀವು ಕಂಡುಕೊಂಡರೆ, ನೀವು ತಕ್ಷಣವೇ ನೋಮ್ ਨਾਲಿ ಸಂಪರ್ಕಿಸಿ ಮತ್ತು ವಿಶೇಷತೆ ಅಥವಾ ಉಲ್ಲಂಘನೆಯ ವಿವರಗಳನ್ನು ಒದಗಿಸಬೇಕು. ',
    block17:
      '((c) ವ്യക್ತिगತ ಡೇಟಾದ ಪ್ರಕ್ರಿಯೆ. ನೀವು ಸೇವೆಯನ್ನು ವ്യക್ತिगತ ಡೇಟಾವನ್ನು ಪ್ರಕ್ರಿಯೆ ಮಾಡಲು ಬಳಸಿದರೆ, ನೀವು ಕಾನುನಿಯಾಗಿ ಸಾಕಷ್ಟು ಪ್ರೈವೇಸಿ ಹೇಳಿಕೆಗಳನ್ನು ಒದಗಿಸಬೇಕು ಮತ್ತು ಅಂತಹ ಡೇಟಾವನ್ನು ಪ್ರಕ್ರಿಯೆ ಮಾಡಲು ಅಗತ್ಯ ಸ್ವಕ್ಷೇಪಗಳನ್ನು ಪಡೆಯಬೇಕು, ಮತ್ತು ನೀವು ಅಪ್ಲಿಕೇಬಲ್ ಕಾನೂನಿನ ಅನುಸಾರ ಅಂತಹ ಡೇಟಾವನ್ನು ಸಂಪಾದಿಸುತ್ತೀರಿ ಎಂದು ನಮಗೆ ವಾರಂಟಿ ನೀಡುತ್ತೀರಿ.',
    block18:
      '(ಎ) ಮುಚ್ಚುವಿಕೆ; ಸ್ಥಗನೆ. ಸೇವೆಯನ್ನು మొదటిసారಿ ಬಳಸಿದ ಕ್ಷಣದಿಂದ આ ಪದಗಳು ಪ್ರಯೋಜಕವಾಗುತ್ತವೆ ಮತ್ತು ಮುಚ್ಚುವವರೆಗೆ અಪ್ರಯೋಜಕವಾಗುವುದಿಲ್ಲ. ಸೇವೆ ಮತ್ತು ವಿಷಯವನ್ನು ಬಳಸುವುದನ್ನು ನಿಲ್ಲಿಸುವ ಮೂಲಕ ನೀವು ಯಾವುದೇ ಕಾರಣಕ್ಕಾಗಿ ಯಾವುದೇ ಸಮಯದಲ್ಲಿ ಈ ಪದಗಳನ್ನು ಮುಚ್ಚಬಹುದು. ಯಾವುದೇ ಕಾರಣಕ್ಕಾಗಿ ಮುನ್ನು ಸೂಚಿಸಿ ನಾವು ಈ ಪದಗಳನ್ನು ಮುಚ್ಚಬಹುದು. ನೀವು ವಿಭಾಗ 2 (ಬಳಕೆ ಮಾನದಂಡಗಳು), ವಿಭಾಗ 5 (ಗোপনীযತೆ, ಸುರಕ್ಷತೆ ಮತ್ತು ಡೇಟಾ ಸಂರಕ್ಷಣೆ), ವಿಭಾಗ 8 (ದಿಸ್ಪ್ಯೂಟ್ ರೆಸಾಲ್ಯುಷನ್) ಅಥವಾ ವಿಭಾಗ 9 (ಸಾಮಾನ್ಯ ಪದಗಳು) ಅನ್ನು ಮತ್ತು ಮಾರ್ಪಡಿಸಿದರೆ, ಅಥವಾ ನಮ್ಮ ನಿಯಂತ್ರಣ ಹೊರತುಪಡಿ ಯಾವುದೇ ಮೂರನೇ ಪಕ್ಷ ತಂತ್ರಜ್ಞಾನ ಪ್ರೊವೈಡರ್との ನಮ್ಮ ಸಂಬಂಧ ಬದಲಾಯಿತು ಅಥವಾ ಕಾನೂನು ಅಥವಾ ಸರ್ಕಾರಿ ಮನವಿ ಪಾಲಿಸಿದರೆ, ನಾವು ನಿಮಗೆ ತಿಳಿಸಿ ತಕ್ಷಣವಾಗಿ ಈ ಪದಗಳನ್ನು ಮುಚ್ಚಬಹುದು. ನೀವು ಈ ಪದಗಳನ್ನು ಪಾಲಿಸದಿದ್ದರೆ, ಅಥವಾ ನಿಮ್ಮ ಬಳಕೆ ನಮಗೆ ಅಥವಾ ಯಾವುದೇ ಮೂರನೇ ಪಕ್ಷಕ್ಕೆ ಸುರಕ್ಷತಾ ಅಪಾಯವನ್ನು ಸೃಷ್ಟಿಸಿದರೆ, ಅಥವಾ ನಿಮ್ಮ ಬಳಕೆ ವಂಚನೆಯಾಗಿದೆ ಅಥವಾ ನಮಗೆ ಅಥವಾ ಯಾವುದೇ ಮೂರನೇ ಪಕ್ಷಕ್ಕೆ ಕ LIABILITY ಹೊಂದಿಸಬಹುದೆಂದು ನಾವು ಶಂಕಿಸಿದರೆ, ನಾವು ಸೇವೆಗೆ ನಿಮ್ಮ ಪ್ರವೇಶವನ್ನು ಸ್ಥಗಿಸಬಹುದು. ',
    block19:
      'ನಿಷ್ಕರ್ಷದ ಪರಿಣಾಮಗಳು. ನಿಷ್ಕರ್ಷದ ನಂತರ, ನೀವು ಸೇವೆಯನ್ನು ಬಳಸುವುದನ್ನು ನಿಲ್ಲಿಸುತ್ತೀರಿ ಮತ್ತು ನಮ್ಮಿಂದ ನಿರ್ದೇಶಿತವಾಗಿ ಯಾವುದೇ ಗोಪ್ಯ ಮಾಹಿತಿಯನ್ನು ತಕ್ಷಣವಾಗಿ ಹಿಂತಿರುಗಿಸಿ ಅಥವಾ ನಾಶ ಮಾಡುತ್ತೀರಿ. ತಮ್ಮ ಪ್ರಕೃತಿಗೆ ಅನುಗುಣವಾಗಿ ನಿಷ್ಕರ್ಷ ಅಥವಾ ಮುಕ್ತಾಯದ ನಂತರ ಉಳಿದಿರಬೇಕಾದ ಈ شرایطಗಳ ಪ್ರावೇಶಗಳು, ಸೆಕ್ಷನ್ 3 ಮತ್ತು 5-9 ಸೇರಿದಂತೆ ಆದರೆ ಇವುಗಳಿಗೆ ಸೀಮಿತವಾಗಿರುವುದಿಲ್ಲ, ಉಳಿದಿರುತ್ತವೆ.',
    block2:
      'ಈ ಬಳಕೆ ಪ್ರಕ್ರಿಯೆಗಳು ನೋಮ්ගේ ಸೇವೆಗಳ ಬಳಕೆಗೆ ಅನ್ವಯಿಸುತ್ತವೆ, ಅವುಗಳಲ್ಲಿ ನಮ್ಮ ಅಪ್ಲಿಕೇಶನ್ ಪ್ರೋಗ್ರಾಮಿಂಗ್ ಇಂಟರ್ಫೇಸ್ಗಳು, ಸಾಫ್ಟ್ವೇರ್, ಉಪಕರಣಗಳು, ಡೆವಲಪರ್ ಸೇವೆಗಳು, ಡೇಟಾ, ದಾಖಲಾತುಗಳು ಮತ್ತು ವೆಬ್ಸೈಟ್ (ಒಟ್ಟಾಗಿ "ಸೇವೆಗಳು" ಎಂದು ಉಲ್ಲೇಖಿಸಲಾಗಿದೆ). ನಮ್ಮ ಸೇವೆಗಳನ್ನು ಬಳಸುವ ಮೂಲಕ, ನೀವು ಈ ನಿಯಮಗಳನ್ನು ಪಾಲಿಸುವುದಕ್ಕೆ ಒಪ್ಪುತ್ತೀರಿ. ನಮ್ಮ ಗೌಪ್ಯತೆ ನೀತಿ ನಮ್ಮು ವ్యక್ತಿ ಮಾಹಿತಿಯನ್ನು ಹೇಗೆ ಸಂಗ್ರಹಿಸುತ್ತೇವೆ ಮತ್ತು ಬಳಸುತ್ತೇವೆ ಎಂಬುದನ್ನು ವಿವರಿಸುತ್ತದೆ.',
    block20:
      'ಪರಿಶೋಧನೆ. ಸೇವೆಯ ಬಳಕೆಯಿಂದ ಹುಟ್ಟುವ ಅಥವಾ ಸಂಬಂಧಿಸಿದ ಯಾವುದೇ ಪ್ರಕಾರದ ಹೇಳಿಕೆಗಳು, ನಷ್ಟಗಳು ಮತ್ತು ವೆಚ್ಚಗಳು (ಅ್ಯಾಟಾರ್ನಿ ಪಾವತಿಗಳು ಸೇರಿದಂತೆ), ನಿಮ್ಮ ವಿಷಯ ವಸ್ತು, ಸೇವೆಗೆ ಸಂಬಂಧಿಸಿದ ಉತ್ಪನ್ನಗಳು ಅಥವಾ ಸೇವೆಗಳ ಬಳಕೆ ಮತ್ತು ಈ ನಿಯಮಗಳ ಅಥವಾ ಅನ್ವಯೋಜ್ಯ ಕಾನೂನಿನ ಉಲ್ಲಂಘನೆಯಿಂದಾಗಿ ನಮ್ಮನ್ನು, ನಮ್ಮ ಸಂಬಂಧಿತ ಸಂಸ್ಥೆಗಳನ್ನು ಮತ್ತು ನಮ್ಮ ಸಿಬ್ಬಂದಿಯನ್ನು ರಕ್ಷಿಸಿ, ಪರಿಶೋಧಿಸಿ ಮತ್ತು ಹಾನಿಯಾಗದಂತೆ ಹೊಂದುತ್ತೀರಿ.',
    block21:
      '(ಬಿ) ಡಿಸ್ಕ್ಲೇಮರ್ಗಳು. ಸೇವೆ "ಇದೇ ರೀತಿ" ಒದಗಿಸಲಾಗಿದೆ. ಕಾನೂನಿನಿಂದ ಅನುಮತಿ ಮಾಡಿದ ಮಟ್ಟಿಗೆ, ನಾವು ಮತ್ತು ನಮ್ಮ ಸಂಬಂಧಿತ ಸಂಸ್ಥೆಗಳು ಮತ್ತು ಲೈಸೆಂಸರ್ಗಳು ಸೇವೆಗೆ ಸಂಬಂಧಿಸಿದ ಯಾವುದೇ ರೀತಿಯ ಪ್ರಾತಿನಿಧ್ಯಗಳು ಅಥವಾ ವಾರಂಟಿಗಳನ್ನು ನೀಡುವುದಿಲ್ಲ ಮತ್ತು ವ್ಯಾಪಾರಕತೆಗಾಗಿ ವಾರಂಟಿಗಳು, ನಿರ್ದಿಷ್ಟ ಉದ್ದೇಶಕ್ಕಾಗಿ ಹೊಂದಿಕೊಳ್ಳುವಿಕೆ, ತೃಪ್ತிகர ಮಟ್ಟ, ಅINFRINGEMENTನ್ನು ಹೊಂದಿಲ್ಲದಿರುವಿಕೆ ಮತ್ತು kwiet್ ಆನಂದದಂತಹ ವಾರಂಟಿಗಳನ್ನು ಸೇರಿ ಆದರೆ ಇವ ಮಾತ್ರವಲ್ಲ, ಮತ್ತು ವ್ಯಾಪಾರದ ವ್ಯವಹಾರದ ಕ್ರಮ ಅಥವಾ ಬಳಕೆಯಿಂದ ಉದ್ಭವಿಸುವ ಯಾವುದೇ ವಾರಂಟಿಗಳನ್ನು ನೀಡುವುದಿಲ್ಲ. ಸೇವೆ ನಿರಂತರ, ಸಕ್ರಿಯ ಅಥವಾ ದೋಷರಹಿತವಾಗಿರುತ್ತದೆ ಅಥವಾ ಯಾವುದೇ ವಿಷಯ ವಿಶೇಷ ಸುರಕ್ಷಿತ, ಕಳೆದುಕೊಳ್ಳುವುದಿಲ್ಲ ಅಥವಾ ಬದಲಾಯಿಸುವುದಿಲ್ಲ ಎಂದು ನಾವು ವಾರಂಟಿ ನೀಡುವುದಿಲ್ಲ.',
    block22:
      '(ಸಿ) ಜವಾಬ್ದಾರಿಯ ಸೀಮಿತಿ: ನಾವು, ನಮ್ಮ ಸಂಬಂಧಿತ ಸಂಸ್ಥೆಗಳು ಅಥವಾ ನಮ್ಮ ಲೈಸెన್ಸರ್ಗಳು ಯಾವುದೇ ಅಪರೋಪಕಾರी, ಆಕಸ್ಮಿಕ, ವಿಶೇಷ, ಅನಂತರ್ಜನಕ ಅಥವಾ ಸಂಶೋಧನಾತ್ಮಕ ಹಾನಿಗಳಿಗೆ ( ಲಾಭ ಕಳೆದು, ಪ್ರಸ್ತುತಿ ಕಳೆದು, ಬಳಕೆ ಕಳೆದು, ಡೇಟা ಕಳೆದು ಅಥವಾ ಇತರ ಅಮೂರ್ತ ಕಳೆದುಗಳನ್ನು ಸೇರಿ) ಜವಾಬ್ದಾರಿ ಹೊಂದುವುದಿಲ್ಲ, ಆದ್ಯಂತ ಈ ರೀತಿಯ ಹಾನಿಗಳ ಸಂಭಾವನೆಯ ಬಗ್ಗೆ ನಮಗೆ ಸಲಹೆ ಮಾಡಲಾಗಿದ್ದರೂ ಸಹ. ಈ شرایط ಪ್ರಕಾರ, ನಮ್ಮ ಒಟ್ಟು ಜವಾಬ್ದಾರಿಯು ಪ್ರಕ್ರಿಯೆಗೆ ಮುನ್ನಿನ ಹನ್ನೊಂದು (12) ತಿಂಗಳುಗಳಲ್ಲಿ ನೀವು ಸೇವೆಗೆ ಪಾವತಿಸಿದ ಶುಲ್ಕ ಅಥವಾ ಒಂದುಶತ್ತು ಯುಎಸ್ ಡಾಲರ್ ($100) (ಏದು ಹೆಚ್ಚು ಅಥವಾ ಹೆಚ್ಚು ಆದುದು) ಅನ್ನು ಮೀರುವುದಿಲ್ಲ. ಈ ವಿಭಾಗದಲ್ಲಿನ ಸೀಮಿತಿಗಳು ಅನ್ವಯನೀಯ ಕಾನೂನಿನಿಂದ ಅನುಮತಿಸಲ್ಪಟ್ಟ ಅತಿ ಅತಿ ಮಟ್ಟದ ಮಟ್ಟಿಗೆ ಅನ್ವಯವಾಗುತ್ತವೆ.',
    block23:
      'ಶರತ್ತುಗಳು ಮತ್ತು ಸೇವೆಗಳನ್ನು ನೀವು ಬಳಸುವುದು ಯುಎಸ್ ಕಾನ್ಫ್ಲಿಕ್ಟ್ ಆಫ್ ಲ್ಯAWS ನಿಯಮಗಳನ್ನು ಹೊರತುಪಡಿಸಿ ಯುನೈಟೆಡ್ ಸ್ಟೇಟ್ಸ್ कાયದ закоನುಗಳಿಂದ ನಿಯಂತ್ರಿಸಲ್ಪಡುತ್ತದೆ. ಅಪ್ಲಿಕೇಶನ್ ಅನ್ನು ನೀವು ಬಳಸುವುದು ಇನ್ನಷ್ಟು ಸ್ಥಳೀಯ, ರಾಜ್ಯ, ರಾಷ್ಟ್ರೀಯ ಅಥವಾ ಅಂತರ್ರಾಷ್ಟ್ರೀಯ ಕಾನೂನುಗಳಿಗೆ ತ подчинಿಯಾಗಬಹುದು. ಈ ಶರತ್ತುಗಳಿಗೆ ಸಂಬಂಧಿಸಿದ ಯಾವುದೇ ಕಾನ್ನಡ ಕ್ರಿಯೆ ಅಥವಾ ಪ್ರಕ್ರಿಯೆ ವಿಶೇಷವಾಗಿ ಯುನೈಟೆಡ್ ಸ್ಟೇಟ್ಸ್ कोर್ಟುಗಳಲ್ಲಿ ಪ್ರಾರಂಭಿಸಲ್ಪಡುವುದು, ಮತ್ತು ನೀವು ಅಂತಹ ಕೋರ್ಟುಗಳ ವೈಯಕ್ತಿಕ ಅಧಿಕಾರಕ್ಷೇತ್ರಕ್ಕೆ ಸುಬ್ಮಿಟ್ ಮಾಡಲು ಒಪ್ಪುತ್ತೀರಿ.',
    block24:
      'ಪಕ್ಷಗಳ ಸಂಬಂಧ. ನೋಮ್ ಮತ್ತು ನೀವು ಸ್ವತಂತ್ರ ಕಂಪನಿಯಾಗಿದ್ದೀರಿ, ಮತ್ತು ಇತರ ಪಕ್ಷದ ಪೂರ್ವ ಲೆಖಿತ ಸಮ್ಮತಿ ಇಲ್ಲದೆ ಯಾವುದೇ ಪಕ್ಷವು ಇತರ ಪಕ್ಷವನ್ನು ಪ್ರತಿನಿಧಿಸುವ ಅಥವಾ ಬಂಧಿಸುವ ಅಥವಾ ಇತರ ಪಕ್ಷಕ್ಕೆ ಕನಿಷ್ಠ ಕನಿಷ್ಠ ಹೊಂದುವ ಅಧಿಕಾರವನ್ನು ಹೊಂದಿಲ್ಲ.',
    block25:
      '(ಬಿ) ಬ್ರ್ಯಾಂಡ್ ಬಳಕೆ. ನಮ್ಮ ಮುನ್ನಿನ ಲಿಪ್ಯಾತ್ಮಕ санಕ್ಷೇಪದ ల್ಲದೆ ನೋಮ್ ಅಥವಾ ಅದರ ಯಾವುದೇ ಸಂಬಂಧಿತ ಸಂಸ್ಥೆಗಳ ಹೆಸರು, ಲೋಗೋಗಳು ಅಥವಾ ಟ್ರೇಡ್ಮಾರ್ಕಗಳನ್ನು ನೀವು ಬಳಸಲಿ ಸಾಧ್ಯವಿಲ್ಲ.',
    block26:
      'ಈ ಪ್ರಕ್ರಿಯೆಗಳ ಯಾವುದೇ ವಿಧಾನವು ಅಮಾನ್ಯ, ಅಕಾನೂನಿಕ ಅಥವಾ అమలు செய்ய முடியாத 것으로 ನಿರ್ಧರிக்கப்பட்டால், ಉಳಿದ ವಿಧಾನಗಳು ಸಂಪೂರ್ಣ ಬಲ ಮತ್ತು ಪರಿಣಾಮದಿಂದ ಕಳೆದುಕೊಳ್ಳುವುದಿಲ್ಲ.',
    block3:
      'ನೀವು 18 ವರ್ಷದ ಕಡಿಮೆ ವಯಸ್ಸಿನವರಾಗಿದ್ದರೆ, ಸೇವೆಯನ್ನು ಬಳಸಲು ನಿಮ್ಮ ಪೋಷಕರು ಅಥವಾ ಕಾನೂನಿ ಗಾರ્ડಿಯನ್ನರ්ගಿಂದ ಅನುಮತಿ ಪಡೆಯಬೇಕು. ನೀವು ಇನ್ನೊಂದು ವ್ಯಕ್ತಿ ಅಥವಾ ಸಂಸ್ಥೆಯ ಹೆಸರಿನಲ್ಲಿ ಸೇವೆಯನ್ನು ಬಳಸುತ್ತಿದ್ದರೆ, ಅವರ ಹೆಸರಿನಲ್ಲಿ ಈ ನಿಯಮಗಳನ್ನು ಸ್ವೀಕರಿಸಲು ನೀವು ಅಧಿಕೃತವಾಗಿರಬೇಕು. ಖಾತೆಯನ್ನು ನೋಂದಾಯಿಸಲು ನೀವು ಸঠিক ಮತ್ತು ಸಂಪೂರ್ಣ ಮಾಹಿತಿ ಒದಗಿಸಬೇಕು. ನಿಮ್ಮ ಸಂಸ್ಥೆಯ ಹೊರಗಿನ ಯেকನ್ನು ವ್ಯಕ್ತಿಗೆ ನಿಮ್ಮ ಪ್ರವೇಶ ಕ್ರೆಡೆನ್ಶಿಯಲ್ಗಳು ಅಥವಾ ಖಾತೆಯನ್ನು ನೀವು ಒದಗಿಸಬಾರದು, ಮತ್ತು ನಿಮ್ಮ ಕ್ರೆಡೆನ್ಶಿಯಲ್ಗಳನ್ನು ಬಳಸಿಕೊಂಡು ನಡೆಸப்படும் ಎಲ್ಲಾ ಚಟುವಟಿಕೆಗಳಿಗೆ ನೀವು ಜವಾಬ್ದಾರಿಯಾಗಿದ್ದೀರಿ.',
    block4:
      '(ಎ) ಸೇವೆಯ ಬಳಕೆ. ಈ شرایطಗಳಡಿಯಲ್ಲಿ ನೀವು ಸೇವೆಗೆ ಪ್ರವೇಶಿಸಬಹುದು, ಮತ್ತು ನಾವು ನಿಮಗೆ ಸೇವೆಯನ್ನು ಬಳಸಲು ಪ್ರಕಟವಾಗಿರದ ಹಕ್ಕನ್ನು ನೀಡುತ್ತೇವೆ. ಸೇವೆಯನ್ನು ಬಳಸುವಾಗಿದ್ದು, ನೀವು ಈ شرایطಗಳು ಮತ್ತು ಎಲ್ಲಾ ಅನ್ವಯೋಜ್ಯ ಕಾನೂನುಗಳನ್ನು ಪಾಲಿಸುತ್ತೀರಿ. ಸೇವೆಯಲ್ಲಿ ಎಲ್ಲಾ ಹಕ್ಕುಗಳು, ಶೀರ್ಷಿಕೆಗಳು ಮತ್ತು ಆಸಕ್ತಿಗಳನ್ನು ನಾವು ಮತ್ತು ನಮ್ಮ ಸಂಬಂಧಿತ ಸಂಸ್ಥೆಗಳು ಸ್ವಾಮೀಕರಿಸುತ್ತೇವೆ.',
    block5:
      'ಫೀಡ್‌ಬ್ಯಾಕ್. ನಾವು ಫೀಡ್‌ಬ್ಯಾಕ್, ವಿಮರ್ಶಗಳು, ಕಲ್ಪನೆಗಳು, ಸಲಹೆಗಳು ಮತ್ತು ಸುಧಾರಣೆಗಳನ್ನು ಸ್ವಾಗತಿಸುತ್ತೇವೆ. ನೀವು આવ soortಿನ ವಿಷಯವನ್ನು ಒದಗಿಸಿದರೆ, ನಾವು ಅದನ್ನು ಯಾವುದೇ ನಿಯಮಿತಿಗಳ brezವಾಗಿ ಮತ್ತು ನಿಮಗೆ ಯಾವುದೇ ಪ್ರತಿ ಹೊಂದirmedೆ ಬಳಸಬಹುದು. ',
    block6:
      '(c) ನಿಷೇಧಗಳು. ನೀವು ಮಾಡಲಾರೆ: (1) ಇತರರ ಹಕ್ಕುಗಳನ್ನು ಉಲ್ಲಂಘಿಸುವ, ಸ್ವಕಾರ್ಯಗೊಳಿಸುವ ಅಥವಾ ಉಲ್ಲಂಘಿಸುವ ರೀತಿಯಲ್ಲಿ ಸೇವೆಯನ್ನು ಬಳಸುವುದು; (2) ರಿವರ್ಸ್ ఇಂಜಿನಿಯರಿಂಗ್, ಡീകಂಪೈಲ್ ಮಾಡುವುದು, ಡಿಸ್ಯಾಸೆಂಬಲ್ ಮಾಡುವುದು, ಅನುವಾದಿಸುವುದು ಅಥವಾ ಸೇವೆ ಮಾದಲಿಗಳು, ಅಲ್ಗಾರಿದಮ್ಗಳು ಮತ್ತು ವ್ಯವಸ್ಥೆಗಳ ಮೂಲ ಕೋಡ್ ಅಥವಾ ಅಂತರ್ಗತ ಅಂಶಗಳನ್ನು ಕಂಡುಹಿಡಿಯಲು ಪ್ರಯತ್ನಿಸುವುದು (ಈ ನಿಷೇಧಗಳು ಅನ್ವಯಿಸಬಲ್ಲ ಕಾನೂನಿನಿಂದ ನಿಷೇಧಿಸಲ್ಪಟ್ಟಿದ್ದರೆ ಹೊರತು); (3) ನೋಮೊಂಗೆ ಸ್ಪರ್ಧಿಸುವ ಮಾದಲಿಗಳನ್ನು ಅಭಿವೃದ್ಧಿಪಡಿಸಲು ಸೇವೆಯ ಆઉಟ್ಪುಟ್ ಅನ್ನು ಬಳಸುವುದು; (4) API ಮೂಲಕ ಅನುಮತಿ ನೀಡಲ್ಪಟ್ಟಿದ್ದಲ್ಲಿ ಹೊರತು, ಸ್ಕ್ರೇಪಿಂಗ್, ವೆಬ್ ಹಾರ್ವೆಸ್ಟಿಂಗ್ ಅಥವಾ ವೆಬ್ ಡೇಟಾ ಆಕ್ಷೇಪಣ ಹೇರಿದಂತೆ ಯಾವುದೇ ಸ್ವಯಂಚಾಲಿತ ಅಥವಾ ಪ್ರೋಗ್ರಾಮಿಂಗ್ ವಿಧಾನಗಳನ್ನು ಬಳಸಿ ಸೇವೆಯಿಂದ ಡೇಟಾ ಅಥವಾ ಆઉಟ್ಪುಟ್ ಅನ್ನು ಆಕ್ಷೇಪಿಸುವುದು; (5) ಸೇವೆಯ ಆઉಟ್ಪುಟ್ ಅನ್ನು ಸಾವಯವ ಸಾಮಗ್ರಿ ಎಂದು ಪ್ರಸ್ತುತಿಸುವುದು (ಇದು ಹोईದಿಲ್ಲ), ಅಥವಾ ನಮ್ಮ ಬಳಕೆ ನಿಯಮಗಳನ್ನು ಉಲ್ಲಂಘಿಸುವುದು; (6) ನಮ್ಮ ಪ್ರಾರಂಭಿಕ ಅನುಮತියಿಲ್ಲದೆ API ಕೀಗಳನ್ನು ಖರೀದಿಸುವುದು, ಮಾರಾಟ ಮಾಡುವುದು ಅಥವಾ ವರ್ಗಾಯಿಸುವುದು; ಅಥವಾ (7) 13 ವರ್ಷಕ್ಕಿಂತ ಕಡಿಮೆ ವಯಸ್ಸಿನ ಮಕ್ಕಳ ಅಥವಾ ಡಿಜಿಟಲ್ ಸನ್ಮತಿ ಸಂಬಂಧಿಸಿದ ಅನ್ವಯಿಸಬಲ್ಲ ವಯಸ್ಸಿನ ವ્યಕ್ತಿ ಮಾಹಿತಿಯನ್ನು ನಮಗೆ ಒದಗಿಸುವುದು. ನೀವು ನಮ್ಮ ಡಾಶನಾತ್ಮಕ ಸ liệuದಲ್ಲಿನ ಯಾವುದೇ ರೇಟ್ ಮಿತಿಗಳು ಮತ್ತು ಇತರ ಅಪೇಕ್ಷೆಗಳಿಗೆ ಪಾಲಿಸುತ್ತೀರಿ.',
    block7:
      'ತಯಾರಿ-ಪಕ್ಷ ಸೇವೆಗಳು. ಸೇವೆಗೆ ಸಂಬಂಧಿಸಿದ ಯಾವುದೇ ತಯಾರಿ-ಪಕ್ಷ ಸಾಫ್ಟ್ವೇರ್, ಸೇವೆಗಳು ಅಥವಾ ಇತರ ಉತ್ಪನ್ನಗಳು ತಮ್ಮ ಸ್ವಂತ شرایطಗಳಿಂದ ನಿಯಂತ್ರಿಸಲ್ಪಡುತ್ತವೆ, ಮತ್ತು ತಯಾರಿ-ಪಕ್ಷ ಉತ್ಪನ್ನಗಳಿಗೆ ನಾವು ಜವಾಬ್ದಾರಿ ಹೊಂದಿಲ್ಲಿ.',
    block8:
      '(ಎ) ನಿಮ್ಮ ವಿಷಯmatter. ನೀವು ಸೇವೆಗೆ ಇನ್ಪುಟ್ ("ಇನ್ಪುಟ್") ಒದಗಿಸಬಹುದು ಮತ್ತು ಇನ್ಪುಟ್ ಆಧಾರದ ಮೇಲೆ ರಚಿಸಲಾದ ಮತ್ತು ಮರಳಿದ આઉಟ್ಪುಟ್ ("ಆઉಟ್ಪುಟ್") ಪಡೆಯಬಹುದು (ಒಟ್ಟಿಗೆ "ವಿಷಯmatter" ಎಂದು ಕರೆಯಲಾಗುತ್ತದೆ). ಪಕ್ಷಗಳ ನಡುವೆ, ಮತ್ತು ಅನ್ವಯೋಜ್ಯ ಕಾನೂನಿನಿಂದ ಅನುಮತಿ ನೀಡಿದ ಮಟ್ಟಿಗೆ, ನೀವು ಎಲ್ಲಾ ಇನ್ಪುಟ್ ಅನ್ನು ಸ್ವಾಮಿ ಮಾಡುತ್ತೀರಿ. ನೋಮ್ ಸೇವೆಯನ್ನು ಒದಗಿಸಲು ಮತ್ತು ನಿರ್ವಹಿಸಲು, ಅನ್ವಯೋಜ್ಯ ಕಾನೂನಿಗಳಿಗೆ ಅನುಸರಿಸಲು ಮತ್ತು ನಮ್ಮ ನೀತಿಗಳನ್ನು ಜಾರಿಗೆ ತರಲು ವಿಷಯmatterವನ್ನು ಬಳಸಬಹುದು. ನೀವು ವಿಷಯmatterಕ್ಕೆ ಜವಾಬ್ದಾರಿ ಹೊಂದುತ್ತೀರಿ, ಅದರಲ್ಲಿ ಅది ಯಾವುದೇ ಅನ್ವಯೋಜ್ಯ ಕಾನೂನಿ ಅಥವಾ ಈ ಪದಗಳನ್ನು ಉಲ್ಲಂಘಿಸುವುದಿಲ್ಲ ಎಂದು ಖಾತ್ರಿಪಡಿಸುವುದನ್ನು ಒಳಗೊಂಡಿದೆ.',
    block9:
      '(ಬಿ) ನಿಖರತा. ಕೃತಕ ಬುದ್ಧಿಮತ್ತೆ ಮತ್ತು ಮೆಷಿನ್ ಲರ್ನಿಂಗ್ ವೇಗವಾಗಿ ವಿಕಸிக்கുന്ന ಸಂಶೋಧನೆ ಕ್ಷೇತ್ರಗಳಾಗಿವೆ. ನಮ್ಮ ಸೇವೆಯನ್ನು ಹೆಚ್ಚು ನಿಖರ, ವಿಶ್ವಾಸಾರ್ಹ, ಸುರಕ್ಷಿತ ಮತ್ತು ಲಾಭകരವಾಗಿ ಮಾಡಲು ನಾವು ನಿರಂತರವಾಗಿ ಪ್ರಯತ್ನಿಸುತ್ತೇವೆ. ಮೆಷಿನ್ ಲರ್ನಿಂಗ್ನ ಪ್ರಾಬಾಶಿಕ ಸ್ವಭಾವದ ಕಾರಣે, ನಮ್ಮ ಸೇವೆಯನ್ನು ಬಳಸುವುದು ಕೆಲವು ಸಂದರ್ಭಗಳಲ್ಲಿ ತಪ್ಪು అవOutputReferenceσματα ನೀಡலாமೆ, ಇದು ನಿಜವಾದ ವ್ಯಕ್ತಿಗಳು, ಸ್ಥಳಗಳು ಅಥವಾ तथ್ಯಗಳನ್ನು ಸঠিকವಾಗಿ ಪ್ರತಿಬಿಂಬಿಸುವುದಿಲ್ಲ. ನಿಮ್ಮ ಬಳಕೆ ಸಂದರ್ಭದ ಆಧಾರದ ಮೇಲೆ ಯಾವುದೇ అవOutputReferenceმის ನಿಖರತೆಯನ್ನು ನೀವು ಸುಲಭವಾಗಿ ಮೌಲ್ಯಮಾಪನ ಮಾಡಬೇಕು, ಮಣುಯಾರಿ ಮಾರ್ಗಕ್ಕೆ ಮೂಲಕ అవOutputReferenceσματαನ್ನು ಪ್ರಶ್ರಯಿಸುವುದು ಸೇರಿದೆ.',
    subTitle1: 'ರೆಜಿಸ್ಟ್ರೇಶನ್ ಮತ್ತು ಪ್ರವೇಶ',
    subTitle10: 'ವಿಭಜನಶಕ್ತಿ',
    subTitle2: 'ಬಳಕೆ ಮಾನದಂಡಗಳು',
    subTitle3: 'ಅನ್ವಯ',
    subTitle4: 'ಶುಲ್ಕ ಮತ್ತು ಪಾವತಿ',
    subTitle5: 'ಗোಪ್ಯತೆ, ಸುರಕ್ಷತೆ ಮತ್ತು ಡೇಟಾ ರಕ್ಷಣೆ',
    subTitle6: 'ಶರತ್ತು ಮತ್ತು ಮುಕ್ತಾಯ',
    subTitle7: 'ತನಿಖೆ; ತಿರಸ್ಕಾರಗಳು; ಜವಾಬ್ದಾರಿ ಮಿತಿ',
    subTitle8: 'ಶಾಸಕ ಕಾನೂನು ಮತ್ತು ಅಧಿಕಾರಕ್ಷೇತ್ರ',
    subTitle9: 'ಸಾಮಾನ್ಯ ಪದಗಳು',
    title: 'ಸೇವಾ ನಿಯಮಗಳು',
    updateTime: 'ಅಪ್ಡೇಟೆ ಮಾಡಲಾಗಿದೆ: ಮಾರ್ಚ್ 15, 2024',
  },
  trialModal: {
    btn: 'ಈಗಲೇ ಪ್ರಾರಂಭಿಸಿ（ಕೇವಲ $0.99）',
    chat: 'ಚ್ಯಾಟಿಪीडಿಎಫ್',
    desc1: 'ನಿಮ್ಮ ಪ್ರಯೋಜನಾಶಯ್ಯದ ನಂತರ, ನಿಮ್ಮ ಮೇಲೆ ವಾರ್ಷಿಕ ಶುಲ್ಕ $180 ವಸूलಿಸಲ್ಪಡುತ್ತದೆ',
    desc2: 'ಯಾವಾಗಲೂ ರದ್ದು ಮಾಡಿ',
    focus: 'ಫೋಕಸ್ ಮಾಡುವುದು',
    hover: 'ಹೋವರ್ ಅನುವಾದ',
    image: 'ಚಿತ್ರ ಅನುವಾದ',
    installBtn: 'ನಿಮ್ಮ ಉಡುಗೊರೆಯನ್ನು ಪಡೆಯရန இப்போதೇ ইನ್ಸ್ಟಾಲ್ ಮಾಡಿ',
    memo: 'ಅಚ್ಚುಮೆಚ್ಚಿನ ವ್ಯವಸ್ಥಾಪನೆ',
    pdf: 'PDFParallelGroup ಶ್ರೇಣಿ ಅನುವಾದ',
    realtime: 'ತಕ್ಷಣ ಅನುವಾದ',
    select: 'ಶಬ್ದ ಆಯ್ಕೆ ಅನುವಾದ',
    title: 'ಸ್ವಾಗತ ಸದಾಶಯೋಜನೆ',
    trialText: '7-ದಿನ ತ್ರಯಿ',
    video: 'ವೀಡಿಯೊ ಅನುವಾದ',
    videoSummary: 'ವೀಡಿಯೊ ಸಾರಾಂಶ',
    web: 'ParallelGroup್ ಅನುವಾದ',
    webSummary: 'ವೆಬ್ ಸಾರಾಂಶ',
  },
  upgradeModal: {
    btn: 'ಈಗ ಅಪ್ಗ್ರೇಡ್ ಮಾಡಿ',
    chat: {
      free: 'ChatPDF ಲಿಮಿಟ್ ತಕ್ಷಣಕ್ಕೆ ತಲುಪಿದ್ದೀರಿ',
      pro: 'ಈ ಮಾಸಕ್ಕೆ ChatPDF ლಿಮಿಟ್ ತಕ್ಷಣವಾಗಿ ತಲುಪಿದ್ದೀರಿ',
    },
    contactStr: 'ಮುಂದಿನ ರೀಸೆಟ್ ಅನ್ನು ಕಾಯ್ದಿರಿ ಅಥವಾ contact@noam.tools ನಲ್ಲಿ ನಮ್ಮೊಂದಿಗೆ ಸಂಪರ್ಕಿಸಿ.',
    limitAlertStr: 'ನಿಮ್ಮ ಫ್ರೀ ಪ್ಲಾನ್ ლಿಮಿಟ್ ತಕ್ಷಣ ಮೀರಿದೆ. ಮುಂದುವರಿಯುವುದಕ್ಕೆ ಅಪ್ಗ್ರೇಡ್ ಮಾಡಿ.',
    more: 'ಯೋಜನೆಗಳನ್ನು ವೀಕ್ಷಿಸಿ',
    pageLimit: { free: 'PDF ಪೇಜ್ ಲಿಮಿಟ್ ತಕ್ಷಣಕ್ಕೆ ತಲುಪಿದ್ದೀರಿ' },
    title: 'ಇರುವಿಕೆ',
    upgradeAlertStr: 'ನಿಮ್ಮ ಫ್ರೀ ಪ್ಲಾನ್ ಲಿಮಿಟ್ ತಕ್ಷಣ ಮೀರಿದೆ. συνέχಿಸಲು ಅಪ್ಗ್ರೇಡ್ ಮಾಡಿ.',
    upload: {
      free: 'ನಿಮ್ಮ PDF ಅನುವಾದ ಮಿತಿ ತಲುಪાઈ ગયಿದೆ',
      pro: 'ಈ ಮಾಸಿಗೆ ನಿಮ್ಮ PDF ಅನುವಾದ ಮಿತಿ ತಕ್ಷಣ ಸಂಪೂರ್ಣವಾಗಿದೆ',
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'ಈಗ ಸೇರಿ',
      label: 'ನವೀನ ಬಳಕೆದಾರ ಪ್ರಯೋಜನಗಳು:',
      remain: 'ಕೇವಲ 30 ಬಳಿ ಉಳಿದಿದೆ',
      text: 'ಕೇವಲ 100 ಸ್ಥಳಗಳು ಲಭ್ಯವಿವೆ! ಈಗಾಗಲೇ ನಿಮ್ಮದನ್ನು ಪಡೆಯಿರಿ!',
    },
  },
  aiPdfTranslator: {
    title: 'ಫ್ರೀ AI ಪಿಡಿಎಫ್ ಅನುವಾದಕ: ಯಾವುದೇ ಭಾಷೆಗಳಲ್ಲಿ ಹೋಲಿಕೆೊಂದಿಗೆ ಪಿಡಿಎಫ್ ಅನ್ನು ಅನುವಾದಿಸಿ',
    desc: 'AI ಮೂಲಕ PDF ಫೈಲ்களನ್ನು எந்தುದೇ ಭಾಷೆಗೆ ಸುಲಭವಾಗಿ ಅನುವಾದಿಸಿ. ಮೂಲ ಮತ್ತು ಅನುವಾದಿತ ಪಠ್ಯವನ್ನು ಪಕ್ಷಪಕ್ಷವಾಗಿ ಹೋಲಿಸಿ, ವೇಗವಾಗಿ ಮತ್ತು ಉಚಿತವಾಗಿ.',
    keywords: 'GPT-4、AI ಸಹಾಯಕ、ಅನುವಾದ、ಸಾರಾಂಶ、ಫೋಕಸ್、ChatPDF、ಮೆಮೊ、ಕಾರ್ಯಕ್ಷಮತೆ',
    sourceToTarget: {
      title: 'ಫ್ರೀ PDF ಅನುವಾದ ಸಾಮಗ್ರಿ: {{source}} ಅನ್ನು {{target}} ಗೆ ಮुफ್ತವಾಗಿ ಅನುವಾದಿಸಿ',
      desc: 'ನಿಮ್ಮ PDF ಫೈಲ்களನ್ನು ಯಾವುದೇ ಮೂಲ ಭಾಷೆಯಿಂದ ನಿಮ್ಮ ಆದ್ಯತಯಿತ ಭಾಷೆಗೆ ಉಚಿತವಾಗಿ ಅನುವಾದಿಸಿ. ಹೆಚ್ಚಿನ ಪ್ರगತಿಪ್ರাপ্ত AI ಯಿಂದ ಸ್ಥಾಪಿತವಾದ ವೇಗית幔, ಸಾಶಯೋಜಿತ ಮತ್ತು ಸುರಕ್ಷಿತ PDF ಅನುವಾದ.',
    },
    headerIntroduce: {
      title: 'ನೋಮ್: ಕೇವಲ ಆನ್ಲೈನ್ ಅನುವಾದ ಮಾತ್ರವಲ್ಲ',
      introduce1: {
        title: 'ನೋಯಮ್ · ಪಿಡಿಎಫ್ ರೀಡರ್',
        desc: '✨ಬದಿ-ಬದಿ ಅನುವಾದ + AI ಪ್ರಶ್ನೆ-ಉತ್ತರ. ಪಿಡಿಎಫ್ ಅನ್ನು ನಿಮ್ಮ ಗೊತ್ತ ಭಾಷೆಗೆ ವೇಗವಾಗಿ ಮತ್ತು ಸঠিকವಾಗಿ ಅನುವಾದಿಸಿ. ನಿಮ್ಮ ಪಿಡಿಎಫ್ ಫೈಲ್ಗಳെക്കുറിച്ച് ಆಳವಾದ ಅರ್ಥವನ್ನು ಪಡೆಯಲು ವಿಷಯದ ಬಗ್ಗೆ ಸ್ವತಂತ್ರವಾಗಿ ಪ್ರಶ್ನೆ ಕೇಳಿ. ',
      },
      introduce2: {
        title: 'ನೋಯಮ್ · ಪಕ್ಷದಿಂದ-ಪಕ್ಷದ ಅನುವಾದ ವಿಸ್ತರಣೆ',
        desc: '👏ನಿಮ್ಮ ಎಲ್ಲಾ ವೆಬ್ಪೇಜ್ ಅನುವಾದ ಅಗತ್ಯಗಳನ್ನು ಪರಿಹರಿಸಿ:',
        detail1: { title: 'ವೆಬ್ಪೇಜ್ ಅನುವಾದ:', desc: 'ಬದಿ-ಬದಿ ದ್ವಿಭಾಷಾ ವೀಕ್ಷಣೆ' },
        detail2: { title: 'ಪದ ಅನುವಾದ:', desc: 'ಒನ್-ಕ್ಲಿಕ್ ತ್ವರಿತ ಅನುವಾದ' },
        detail3: { title: 'ತಕ್ಷಣ ಅನುವಾದ:', desc: 'ಶಬ್ದಗಳು ಅಥವಾ ವಾಕ್ಯಗಳನ್ನು ತಕ್ಷಣವಾಗಿ ಅನುವಾದಿಸಿ.' },
        detail4: { title: 'ಇಮೇಜ್ ಅನುವಾದ:', desc: 'ಚಿತ್ರಗಳನ್ನು ಅನುವಾದಿತ ಚಿತ್ರಗಳಿಂದ ಬದಲಾಯಿಸಿ.' },
        detail5: { title: 'ವೀಡಿಯೊ ಅನುವಾದ:', desc: 'ಉತ್ತಮ ವೀಕ್ಷಣೆಗಾಗಿ ದ್ವಿಭಾಷೀಯ උಪಶ್ರೇಷ್ಠಿಕೆಗಳು.' },
        footer: 'ಸ್ಮಾರ್ಟರ್ ಅನುವಾದಕ್ಕಾಗಿ ಹೆಚ್ಚಿನ AI-ಶಕ್ತಿ ಪ್ರಾರಂಭಿತ ಓದುವ ವಿಶೇಷತೆಗಳನ್ನು ಅನುಭವಿಸಿ!',
      },
    },
    subtitle: 'PDF ಅನ್ನು ಆನ್ಲೈನ್ ಮुफ್ತದಲ್ಲಿ ಅನುವಾದಿಸಿ',
    introduce: {
      module1: {
        detail1: {
          title: 'ರಿಯಾಲ್-ಟೈಮ್ ಸೈಡ್-ಬೈ-ಸೈಡ್ ಪಿಡಿಎಫ್ ಅನುವಾದ',
          desc1:
            'ಮೂಲ ಮತ್ತು ಅನುವಾದಿತ ವಿಷಯವನ್ನು ತಕ್ಷಣವಾಗಿ ಸಿಂಕ್ರೊನೈಸೆಡ್ ಸೈಡ್-ಬೈ-ಸೈಡ್ ಲೇಯเอಉಟ್ನಲ್ಲಿ ಪ್ರದರ್ಶಿಸಿ',
          desc2:
            'ಸಿಂಕ್ರೊನೈಸ್ ಸ್ಕ್ರೋಲಿಂಗ್ ಅನ್ನು ഉപಯೋಗಿಸಿ ಸಾಮಗ್ರಿಗಳ બંને ಆವೃತ್ತಿಗಳನ್ನು ಸುಲಭವಾಗಿ ಹೋಲಿಸಿ',
          desc3: 'ಸ್ಥಿರವಾದ ಓದುವ ಅನುಭವ ਲਈ ಒಂದೇ ರೂಪಣೆಯನ್ನು જાળવಿ',
        },
        detail2: {
          title: 'ನಿಖರವಾದ ವಿಷಯದ ಸಂರಕ್ಷಣೆ ಮತ್ತು ಪರಿಶೀಲನೆ',
          desc1: 'ಸರળ ಪರಿಶೀಲನೆಗಾಗಿ ಮೂಲ ಮತ್ತು ಅನುವಾದಿತ ಪಠ್ಯದ মধ್ಯে ಸಂಪೂರ್ಣ ಸಾಮರ್ಥ್ಯ',
          desc2: 'ಎರಡೂ ಆವೃತ್ತಿಗಳಲ್ಲಿ ವಿಷಯದ ಪ್ರತಿ ವಿಭಾಗವು ზუსტವಾಗಿ ಹೊಂದುತ್ತದೆ',
          desc3:
            'ವಿಶ್ವಾಸಾರ್ಹ ಫಲಿತಾಂಶಗಳಿಗಾಗಿ ಅನುವಾದ ವ್ಯತ್ಯಾಸಗಳನ್ನು ತ್ವರಿತವಾಗಿ ಪತ್ತೆ ಮಾಡಿ ಮತ್ತು పరಿಹರಿಸಿ',
        },
      },
      module2: {
        detail1: {
          title: 'ಸटीक ಅನುವಾದಕ್ಕಾಗಿ ಮಲ್ಟಿಪಲ್ ಅಡ್ವಾನ್ಸ್ಡ್ AI ಮಾದலുകൾ',
          desc1: 'ನಿಮ್ಮ ಅನುವಾದ ಅಗತ್ಯಗಳಿಗೆ ಹೊಂದಿಸಲು ಮುನ್ನೆಚ್ಚಿನ AI ಮಾದലುಗಳಿಂದ ಆಯ್ಕೆ ಮಾಡಿ',
          desc2: 'ವಿವಿಧ ದಾಶಪత್ರ ಪ್ರಕಾರಗಳು ಮತ್ತು ಉದ್ಯೋಗಗಳಿಗೆ ಸೂಕ್ಷ್ಮ ಫಲಿತಾಂಶಗಳನ್ನು ಖಚಿತಪಡಿಸಿ',
          desc3:
            'ಸ್ಥಳೀಯತೆಯ ಮಾದರಿ ಆಯ್ಕೆಗಳು ಪ್ರತಿ ಸನ್ನಿವೇಶಕ್ಕೆ ಅಗತ್ಯವಾಗಿ ಅಳವಡಿಸಿದ ಪರಿಹಾರಗಳನ್ನು ಒದಗಿಸುತ್ತವೆ',
        },
        detail2: {
          title: 'ಪ್ರತಿಯೊಂದು ವಿಷಯದ ಪ್ರಕಾರಕ್ಕೆ ಅಡ್ವಾನ್ಸ್ಡ್ AI ಅನುವಾದ',
          desc1:
            'ನಮ್ಮ ಶಕ್ತಿಶಾಲಿ AI ಮೋಡಲ್ ಹೆಚ್ಚಿನ ನಿಖರತೆ ಮತ್ತು ನೈಸರ್ಗಿಕ ಭಾಷা ಅರ್ಥವನ್ನು ಸुनिश्चित කරುತ್ತದೆ',
          desc2: 'ತಾಂತ್ರಿಕ, ಶೈಕ್ಷಣಿಕ ಮತ್ತು ಸೃಜನಶೀಲದ ದಸ್ತಾವೇಜುಗಳನ್ನು ಸುಲಭತೆಯಿಂದ ಸಂಪಾದಿಸುತ್ತದೆ',
          desc3: 'ನಿಮ್ಮ ಎಲ್ಲಾ ಅನುವಾದ ಅಗತ್ಯಗಳಿಗಾಗಿ ನಂಬಿಗಸ್ತ ಫಲಿತಾಂಶಗಳನ್ನು வழங்குகிறது',
          desc4: 'ಅತ್ಯುತ್ತಮ ಕಾರ್ಯನಿರ್ವಹಣೆಗಾಗಿ ವಿವಿಧ ವಿಷಯ ವಿಧಗಳಿಗೆ ಬುದ್ಧಿಶಾಲಿ ಪ್ರಯೋಜನೆ',
        },
      },
      module3: {
        detail1: {
          title: 'ಬುದ್ಧಿಮತ್ತായ ದಾಶಪత್ರ ಸಂವಾದ',
          desc1:
            'ಅಡ್ವಾನ್ಸ್ಡ್ AI ಅನ್ನು ಬಳಸಿ ನಿಮ್ಮ PDF ಮತ್ತು ಪ್ರೆಸೆಂಟೇಶನ್ ಫೈಲ್‌ಗಳೊಂದಿಗೆ ಸುಲಭವಾಗಿ ಚ್ಯಾಟ್ ಮಾಡಿ',
          desc2:
            'ದოკ್ಯುಮೆಂಟ್ ವಿಷಯದ ಬಗ್ಗೆ ತಕ್ಷಣವಾಗಿ ಪ್ರಶ್ನೆಗಳನ್ನು ಕೇಳಿ ಮತ್ತು ಸಾಶಯತ್ತರ ಉತ್ತರಗಳನ್ನು ಪಡೆಯಿರಿ',
          desc3: 'ದೀರ್ಘದ ಸದಾಶಯಗಳಿಗೆ ವೇಗವಾಗಿ ಸಂಕ್ಷಿಪ್ತ ಸಾರಾಂಶಗಳನ್ನು ಉತ್ಪಾದಿಸಿ',
        },
        detail2: {
          title: 'ಊಳವಿಷಯ ವಿಶ್ಲೇಷಣೆ ಮತ್ತು ಸುಲಭ ಸಂಯೋಜನೆ',
          desc1:
            'AI-ಶಕ್ತಿ ಮೀರಿದ ಅರ್ಥದೊಂದಿಗೆ ಪ್ರಮುಖ ಮಾಹಿತಿ ಆದ್ಯತಮ ಮಾಡಿ ಮತ್ತು ಸಂಕೀರ್ಣ ಡೇಟಾವನ್ನು ವಿಶ್ಲೇಷಿಸಿ',
          desc2: 'ತಾಂತ್ರಿಕ, ಅಕಾಡೆಮಿಕ್ ಅಥವಾ ಸೃಜನಶೀಲ ವಸ್ತುಗಳಲ್ಲಿ ಆಳವಾಗಿ ತಿಳಿಯಿರಿ',
          desc3:
            'ಪೂರ್ಣ ದಾಶಪత್ರ ನಿರ್ವಹಣಾ ಸોલ್ಯೂಷನ್ కోసం ನಮ್ಮ PDF ಟ್ರಾನ್ಸ್ಲೇಟರ್ೊಂದಿಗೆ ಸುವ್ಯವಸ್ಥಿತವಾಗಿ ಸಂಯೋಜಿಸುತ್ತದೆ',
        },
      },
      module4: {
        detail1: {
          title: 'PDF ಅನುವಾದದ ಹೆಚ್ಚು: ಆಲ್-ಇನ್-ವನ್ ವೆಬ್ಪೇಜ್ ಅನುವಾದ ಪರిష್ಕಾರ',
          desc: 'ಪ್ರತಿ ಆನ್ಲೈನ್ ಓದುವ ಸನ್ನಿವೇಶಕ್ಕೆ ವಿನ್ಯಾಸಗೊಳಿಸಲಾದ ನಮ್ಮ ಪ್ರಬಲ ಸೈಡ್-ಬೈ-ಸೈಡ್ ಅನುವಾದ ವಿಸ್ತರಣೆಯನ್ನು ಕಂಡುಹಿಡಿಯಿರಿ.',
          desc1:
            'ವೆಬ್ಪೇಜ್ ಅನುವಾದ: ಸಿಂಕ್ರೊನೈಸ್ ಮಾಡಿದ ಪಕ್ಷ-ಇದ್ದ ಪ್ರದರ್ಶನದೊಂದಿಗೆ ದ್ವಿಭಾಷಾ ವಿಷಯವನ್ನು ಆನಂದಿಸಿ',
          desc2: 'ಪದ ಅನುವಾದ: ಒಂದು ಕ್ಲಿಕ್ ಮூலம் ಪ್ರಕಾಶಿತ ಪದಗಳನ್ನು ತಕ್ಷಣವಾಗಿ ಅನುವಾದಿಸಿ',
          desc3:
            'ತಕ್ಷಣ ಅನುವಾದ: ತ್ವರಿತ ಅರ್ಥವನ್ನು ಪಡೆಯಲು ಯಾವುದೇ ಪಠ್ಯ ಅಥವಾ ವಾಕ್ಯವನ್ನು ತಕ್ಷಣದಲ್ಲಿ ಅನುವಾದಿಸಿ',
          desc4: 'ಇಮೇಜ್ ಅನುವಾದ: ಮೂಲ ಚಿತ್ರಗಳನ್ನು ಸ್ವಯಂಚಾಲಿತವಾಗಿ ಅನುವಾದಿತ ಆವೃತ್ತಿಗಳೊಂದಿಗೆ ಬದಲಾಯಿಸಿ',
          desc5:
            'ವೀಡಿಯೊ ಅನುವಾದ: ಸುಧಾರಿತ ಅನುಭವಕ್ಕಾಗಿ ದ್ವಿಭಾಷಾ ಸಬ್ಟೈಟಲ್ಗಳೊಂದಿಗೆ ವೀಡಿಯೋಗಳನ್ನು ವೀಕ್ಷಿಸಿ',
        },
      },
    },
    question: {
      title: 'ಪ್ರಶ್ನೆಗಳು ಮತ್ತು ಉತ್ತರಗಳು',
      answer1: {
        title:
          'ನೋಮ್ ಪಿಡಿಎಫ್ ಅನುವಾದಕನ್ನು ಪಿಡಿಎಫ್ ಅನುವಾದಕ್ಕೆ ಉಪಯೋಗಿಸಲು ವಿಶೇಷವಾಗಿ ಖರೀದಿಸಬೇಕೇ ಅಥವಾ ಉಚಿತವಾಗಿದೆ?',
        content:
          'ಹೌದು, ಸೈಡರ್ ಪಿಡಿಎಫ್ ಟ್ರಾನ್ಸ್ಲೇಟರ್ ನೊಂದಿಗೆ ನೀವು ಪಿಡಿಎಫ್ಗಳನ್ನು ಉಚಿತವಾಗಿ ಅನುವಾದಿಸಬಹುದು! ನಾವು 5,000 ಟೋಕನ್ಗಳ ಉಚಿತ ಕೋಟಾವನ್ನು ಒದಗಿಸುತ್ತೇವೆ, ಇದು ಮಾರ್ಕೆಟ್‌ನಲ್ಲಿ ಸಾಮಾನ್ಯವಾಗಿ ಕಂಡುಬರುವ רוב meisten ಪಿಡಿಎಫ್ ದಸ್ತಾವೇಜುಗಳನ್ನು ಅನುವಾದಿಸಲು ಸಾಕಷ್ಟು. ನೀವು ದೊಡ್ಡ ಫೈಲ்களನ್ನು ಅನುವಾದಿಸಬೇಕಾಗಿದ್ದರೆ ಅಥವಾ ಅಡ್ವಾನ್ಸ್ಡ್ ವಿಶೇಷಣಗಳನ್ನು ಅಗತ್ಯವಿದ್ದರೆ, ಇನ್ನಷ್ಟು ಸಾಮರ್ಥ್ಯಗಳಿಗಾಗಿ ನಮ್ಮ ಪ್ರೀಮಿಯಮ್ ಪ್ಲಾನ್ಗಳಿಗೆ ಅಪ್ಗ್ರೇಡ್ ಮಾಡಲು ಆಯ್ಕೆ ಮಾಡಬಹುದು. ',
      },
      answer2: {
        title: 'ನೋಮ್ ಪಿಡಿಎಫ್ ಅನುವಾದಕ ಹೆಚ್ಚು ಸटीकදೆ?',
        content:
          'ನೋಮ್ ಪಿಡಿಎಫ್ ಅನುವಾದಕ ಹೆಚ್ಚಿನ ಸಾಮರ್ಥ್ಯದΑΙ ತಂತ್ರಜ್ಞಾನವನ್ನು ಬಳಸಿಕೊಂಡು ಮತ್ತು ನಿಮ್ಮ ದಸ್ತಾವೇಜುಗಳ ಸನ್ನಿವೇಶವನ್ನು ಆಳವಾಗಿ ಅರ್ಥಮಾಡಿಕೊಂಡು ಅತಿ ಸಂಕ್ಷಿಪ್ತ ಮತ್ತು ನಿಖರವಾದ ಅನುವಾದಗಳನ್ನು ಒದಗಿಸುತ್ತದೆ. ಯಾವುದೇ ಸ್ವಯಂಚಾಲಿತ ಅನುವಾದ ಸಂಪೂರ್ಣವಾಗಿಲ್ಲದಿದ್ದರೂ, ನಮ್ಮ ಪಕ್ಷ-ಪಕ್ಷ ಪ್ರದರ್ಶನವು ನಿಮಗೆ ಪ್ರತಿ ಅನುವಾದವನ್ನು ಸುಲಭವಾಗಿ ಪರಿಶೀಲಿಸಲು ಮತ್ತು ಸುಧಾರಿಸಲು ಅನುವಯವಾಗುತ್ತದೆ, ಅಂತಿಮ ಫಲಿತಾಂಶವು ನಿಮ್ಮ ಗुणಮಟ್ಟದ ಆಶಯಗಳನ್ನು ಪೂರೈಸುತ್ತದೆ ಎಂದು ಖಚಿತಪಡಿಸುತ್ತದೆ. ನೋಮ್ೊಂದಿಗೆ ನಂಬಲಾಗುವ ಮತ್ತು ನಿಖರವಾದ ಪಿಡಿಎಫ್ ಅನುವಾದ ಅನ್ನು ಅನುಭವಿಸಿ.',
      },
      answer3: {
        title: 'ಸ್ಕ್ಯಾನ್ ಮಾಡಿದ ಪಿಡಿಎಫ್ಗಳನ್ನು ನಾನು ಅನುವಾದಿಸಬಹುದೇ?',
        content:
          'ಹೌದು, ನಿಮ್ಮ ಸ್ವಯಂ ಸ್ಥಾಪಿತ OCR (ಓಪ್ಟಿಕಲ್ ಕ್ಯಾರ್ಯಾಕ್ಟರ್ ರೆಕ್ಕನಿಷನ್) ತಂತ್ರಜ್ಞಾನದೊಂದಿಗೆ ಸ್ಕ್ಯಾನ್ ಮಾಡಿದ PDFಗಳನ್ನು ಅನುವಾದಿಸಬಹುದು. ನಮ್ಮ ಸಿಸ್ಟಮ್ ಸ್ಕ್ಯಾನ್ ಮಾಡಿದ ದಾಖಲೆಗಳು ಮತ್ತು ಇಮೇಜ್-ಆಧಾರಿತ PDFಗಳಿಂದ ಪಠ್ಯವನ್ನು ಸ್ವಯಂಚಾಲಿತವಾಗಿ ಹೊರತೆಗೆಯುತ್ತದೆ, ನಂತರ ವಿಷಯವನ್ನು ನಿಮಗಾಗಿ ಅನುವಾದಿಸುತ್ತದೆ. ಇದು ಸಂಪಾದನೆ ಮಾಡಲಾಗದ ಅಥವಾ ಇಮೇಜ್ ಮಾತ್ರ ಮಾಡಿದ PDFಗಳಿಗೆ ಸಹ ನಿಖರವಾಗಿ ಅನುವಾದಿಸಲಾಗುತ್ತದೆ ಎಂದು ಖಚಿತಪಡಿಸುತ್ತದೆ.',
      },
      answer4: {
        title: 'ಭಾಷಾಂತ್ರಕ್ಕೆ ಎಷ್ಟು ಸಮಯ ತೆಗೆಯುತ್ತದೆ?',
        content:
          'ಭಾಷಾಂತ್ರ ಮြနspeed ಮತ್ತು ದಕ್ಷವಾಗಿದೆ—ಬیشಪ್ರಕಾರದ ದಸ್ತಾವೇಜುಗಳು ಅವುಗಳ ಉದ್ದ ಮತ್ತು ಸಂಕೀರ್ಣತೆಯ ಅವলಂಬಿತವಾಗಿ ಸೆಕೆಂಡುಗಳಿಂದ થдыಿ ನಿಮಿಷಗಳವರೆಗೆ ಪ್ರಕ್ರಿಯೆ ಮಾಡಲ್ಪಡುತ್ತವೆ. ಉದಾಹರಣೆಗೆ, ಸ್ಟ್ಯಾಂಡರ್ಡ್ 10-ಪುಟದ ಪಿಡಿಎಫ್ ಅನ್ನು ಅನುವಾದಿಸಲು ಸಾಮಾನ್ಯವಾಗಿ 2 ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ ಸಮಯ ತೆಗೆದುಕೊಳ್ಳುತ್ತದೆ. ನಿಮ್ಮ ಎಲ್ಲಾ ದಸ್ತಾವೇಜು ಅನುವಾದ ಅಗತ್ಯಗಳಿಗಾಗಿ ತ್ವರಿತ ಪ್ರಾರಂಭಿಕ ಸಮಯಗಳನ್ನು ಆನಂದಿಸಿ!',
      },
      answer5: {
        title: 'ಓದುವಿಕೆಗಾಗಿ ಸೈಡ್-ಬೈ-ಸೈಡ್ ವ್ಯూ ಅನ್ನು ಕಳೆದುಕೊಳ್ಳಬಹುದೇ?',
        content:
          'ಹೌದು, ನೀವು ಯಾವಾಗಲೂ ನಿಮ್ಮ ದಾಶಯನೆಗಳನ್ನು ಪಕ್ಷದೊಂದಿಗೆ ಓದಬಹುದು. ಈ ಲೇಯაუთ್ ನಿಮಗೆ ಮೂಲ ಮತ್ತು ಅನುವಾದಿತ ವಿಷಯವನ್ನು ಸುಲಭವಾಗಿ ಹೋಲಿಸುವ ಅನುವೇಷಿಕೆಯನ್ನು ನೀಡುತ್ತದೆ, ಸ್ನೋತಕ ಮತ್ತು ದಕ್ಷವಾದ ಓದುವ ಅನುಭವವನ್ನು ഉറപ്പಿಸುತ್ತದೆ.',
      },
    },
    freeTrial: 'ಫ್ರೀ ಟ್ರಯಲ್',
    toLanguage: { title: 'PDF AI ಅನುವಾದ ஜೋಡಿಗಳು', item: '{{source}} ಗಿಂತ {{target}}' },
  },
  aiPdfTranslate: {
    header: {
      pricing: 'ಬೆಲೆ ನಿಗದಿ',
      faq: 'ಪದೇ ಪದೇ ಕೇಳಲಾಗುವ ಪ್ರಶ್ನೆಗಳು',
      features: 'ವಿಶೇಷಣಗಳು',
      button: 'ಈಗ ಅನುವಾದಿಸಿ',
      blog: 'ಬ್ಲಾಗ್',
    },
    hero: {
      upload: {
        title: 'ನಿಮ್ಮ PDF ಅನ್ನು ಅಪ್ಲೋಡ್ ಮಾಡಿ',
        desc: 'ಅಥವಾ ಡ್ರ್ಯಾಗ್ & ಡ್ರಾಪ್',
        highlight: 'ಬ್ರೌಸ್ ಮಾಡಲು ಕ್ಲಿಕ್ ಮಾಡಿ',
        max: 'ಮ್ಯಾಕ್ಸ್',
      },
      pill: 'AI-ಶಕ್ತಿಯ ಪಡಿಎಫ್ ಅನುವಾದಕ',
      to: 'ಗೆ',
      title: 'ಮुफ್ತ PDF ಅನುವಾದಕ',
      model: 'GPT-4 ಮತ್ತು ಕ್ಲಾಡ್',
      support: 'OCR ಸಪೋರ್ಟ್',
      desc: 'ಮೂಲ ಲೇಯაუთ್ ಅನ್ನು ಸಂಪಾದಿಸುವ ತಕ್ಷಣ, ನಿಖರ ಅನುವಾದಗಳು. ನೋಮ್ AI OCR ಮತ್ತು ಪಕ್ಷ-ಇದೇ ಪ್ರಕ್ಷೇಪಗಳನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ.',
      complete: 'ಅನುವಾದ ಪೂರ್ಣ',
      free: 'ಮुफ್ತ ಪ್ರಯತ್ನ',
      translated: 'ನೋಮ್ ಅವರು ಅನುವಾದಿಸಿದ',
    },
    ticker: {
      ocr: 'ಓಸಿಆರ್ ತಂತ್ರಜ್ಞಾನ',
      multi: 'ಬಹು-ಭಾಷೆ',
      side: 'ಇಬಡಿ-ಇಬಡಿ',
      chat: 'PDF ಗೊಂದಿಗೆ ಚ್ಯಾಟ್ ಮಾಡಿ',
      web: 'ವೆಬ್ ಅನುವಾದ',
      secure: 'ಸುರಕ್ಷಿತ ಮತ್ತು persoonlijk',
      format: 'ಫಾರ್ಮ್ಯಾಟ್ ರಿಟೆನ್ಷನ್',
      pdf: 'ಪಿಡಿಎಫ್ ಅನುವಾದ',
    },
    comparison: {
      bad: {
        text1: 'ದೋಷ: ಲೇಯ அவிழ்ந்தது. ಚಿತ್ರಗಳು ತಪ್ಪಾಗಿ ಇರுக்கின்றன.',
        head: 'ಫಾರ್ಮ್ಯಾಟಿಂಗ್ ಮತ್ತು ಸನ್ನಿವೇಶವನ್ನು ಕಳೆದುಕೊಂಡಿದೆ',
        text2:
          'ಪಠ್ಯಗಳು ಆವರ್ತಿಸುತ್ತವೆ ಮತ್ತು ಫಾಂಟ್ಗಳು ಸ್ಥಿರವಾಗಿಲ್ಲ. ಓದಲು ಕಷ್ಟ ಮತ್ತು ಪ್ರೊಫೆಷನಲ್ ಅಲ್ಲ...',
        title: 'ಮानक ಅನುವಾದ',
      },
      dump: { title: 'ಪ್ಲೇನ್ ಟೆಕ್ಸ್ಟ್ ಡಂಪ್' },
      good: {
        title: 'ನೋಮ್ ஏಐ ಅನುವಾದ',
        sub: 'ಸಂಪೂರ್ಣ ಫಾರ್ಮ್ಯಾಟಿಂಗ್, ಸನ್ನಿವೇಶ ಪ್ರಜ್ಞಿತ',
        tag: 'ಶ್ರೀಮತಿ ಫಲಿತ',
      },
      title: 'ನೋಮ್ AI ಅನ್ನು ಏಕೆ ಆಯ್ಕೆ ಮಾಡಬೇಕು?',
      desc: 'ಕಾಪಿ-ಪೇಸ್ಟ್ ಅನುವಾದದೊಂದಿಗೆ ಸಂಘರ್ಷಿಸುವುದನ್ನು ನಿಲ್ಲಿಸಿ. ಸ್ಟ್ಯಾಂಡರ್ಡ್ ಸಾಮಗ್ರಿಗಳು ಮತ್ತು ನಮ್ಮ AI-ಶಕ್ತಿ ಪ್ರವೇಶಿತ ಸನ್ನಿವೇಶ-ಅನುವೇಷಕ ಅನುವಾದ ನಡುವಿನ ವ್ಯತ್ಯಾಸವನ್ನು ಅನುಭವಿಸಿ.',
    },
    showcase: {
      kicker: 'ಬೆಂಬಲಿತ ದಾಶಯಗಳು',
      title1: 'ಯಾವುದೇ ದಾಶಪತ್ರ',
      carousel1: 'ಕಲೆ',
      carousel2: 'ವಾಸ್ತುಶಿಲ್ಪ',
      title2: 'ಯಾವುದೇ ಭಾಷೆ',
      carousel4: 'ಔಷಧಿ',
      carousel3: 'ಅಕಾಡೆಮಿಕ್ ಜರ್ನಲ್',
      note: 'ತಾಂತ್ರಿಕ, ಅಕಾಡೆಮಿಕ್ ಮತ್ತು ಸೃಜನಶೀಲ ದಾಖಲೆಗಳನ್ನು ಸುಲಭತೆಯಿಂದ ಸಂਭਾਲಿ.',
      carousel6: 'ಕಾನೂನು',
      carousel5: 'ವಿತ्त',
      carousel7: 'ಒಪ್ಪಂದ',
      carousel8: 'ನಿಯಮ',
    },
    features: {
      big: {
        title: 'ಅಡ್ವಾನ್ಸ್ಡ್ AI ಮಾಡೆಲ್‌ಗಳು (GPT-4, ಕ್ಲೋಡ್)',
        desc: 'ನಿಮ್ಮ ಅನುವಾದ ಅವಶ್ಯಕತೆಗಳಿಗೆ ಹೊಂದಿಸಲು ಮುನ್ನೆಚ್ಚಿನ AI ಮಾದেলുകളಿಂದ ಆಯ್ಕೆಮಾಡಿ. ವಿವಿಧದ ಪ್ರಕಾರದ ದಾಶ್ಯಗಳಿಗೆ ಸುಪ್ರಾಮುಖ್ಯ ಫಲಿತಾಂಶಗಳನ್ನು ಖಾತ್ರಿಪಡಿಸಿ.',
      },
      grid1: {
        title: 'OCR ಸಪ್ಪೋರ್ಟ್',
        desc: 'ಸ್ಕ್ಯಾನ್ ಮಾಡಿದ ಪಿಡಿಎಫ್ ಮತ್ತು ಚಿತ್ರಗಳಿಂದ ಪಠ್ಯವನ್ನು ತಕ್ಷಣವಾಗಿ ಹೊರತೆಗೆದುಕೊಳ್ಳಿ ಮತ್ತು ಅನುವಾದಿಸಿ.',
      },
      grid2: {
        title: 'ಹೈ-ರೆಸ್ ఎక್ಸ್ಪೋರ್ಟ್',
        desc: 'ಮೂಲ ಲೇಯ அவತರಣೆಗೊಂದಿಗೆ PDF ಫಾರ್ಮ್ಯಾಟದಲ್ಲಿ ನಿಮ್ಮ ಅನುವಾದಿತ ದಾಶ್ಯಗಳನ್ನು ಡೌನ್ಲೋಡ್ ಮಾಡಿ.',
      },
      grid3: {
        desc: 'ಮೂಲ ಮತ್ತು ಅನುವಾದಿತ ಪಠ್ಯವನ್ನು ಹೋಲಿಸುವ ಸಿಂಕ್ರೊನೈಸ್ ಸ್ಕ್ರೋಲಿಂಗ್.',
        title: 'ಬದಿ-ಬದಿ ಹೋಲಿಕೆ',
      },
      title1: 'ಕೇವಲ ಅನುವಾದಕ್ಕಿಂತ ಹೆಚ್ಚು',
      line1: 'ತಾಂತ್ರಿಕ ಪೇಪರ್.pdf',
      line2: 'ಭಾಷೆಯನ್ನು ಪತ್ತೆ ಮಾಡುತ್ತಿದೆ: ಇಂಗ್ಲಿಷ್...',
      title2: 'ಇದು ಒಂದು ಕ್ರಾಂತಿ',
      line4: 'ಅನುವಾದ ಪೂರ್ಣ (99% ಸ್ಥಳತನಕತೆ)',
      line3: 'ಮಾಡೆಲ್: GPT-4o (ಹೆಚ್ಚಿನ ಸიზ್ಮಿತಿ)',
    },
    testimonials: {
      review1: {
        role: 'ಶೋಧಕ',
        content:
          'ನೋಮ್ ಎಐએನಿ ಅಕಾಡೆಮಿಕ್ ಪೇಪರ್ ಅನ್ನು ಅನುವಾದಿಸುವುದಕ್ಕೆ ನನಗೆ ಗಂಟೆಗಳಷ್ಟು ಸಮಯ ಉಳಿಸಿತು. ತಕನಿಕಿ ಪದಗಳನ್ನು சரಿಪಡಿಸಲು ಪಕ್ಷ-ಪಕ್ಷದ ವ್ಯೂ ಅತ್ಯಂತ ಉಪಯುಕ್ತವಾಗಿದೆ.',
      },
      review2: {
        role: 'ಗ್ಲೋಬಲ್ ಮಾರ್ಕೆಟರ್',
        content:
          'ನಾನು ಬಳಸಿದ ಅತ್ಯುತ್ತಮ PDF ಅನುವಾದಕ. ಇದು ಮೂಲ ಫಾರ್ಮ್ಯಾಟಿಂಗ್ ಅನ್ನು ಸಂಪೂರ್ಣವಾಗಿ ಕಾಪಾಡುತ್ತದೆ, ಇದು ನಮ್ಮ ಮಾರ್ಕೆಟಿಂಗ್ ಡೆಕ್‌ಗಳಿಗೆ ಅತ್ಯಗತ್ಯವಾಗಿದೆ.',
      },
      review3: {
        role: 'ಕಾನೂನಿ ಸಲಹೆಗಾರ',
        content:
          'ಶ್ರೀಮತಿ ಮತ್ತು ವೇಗी. ನಾನು ಅದನ್ನು ಕಾನ್ಸ್ಟ್ರ್ಯಾಕ್ಟ್ ಅನುವಾದಗಳಿಗಾಗಿ ಬಳಸುತ್ತೇನೆ ಮತ್ತು ಸ್ಕ್ಯಾನ್ ಮಾಡಲಾದ ದಾಖಲೆಗಳಿಗಾಗಿ OCR ವಿಶೇಷತೆಯು ತಪ್ಪರಹಿತವಾಗಿ ಕಾರ್ಯನಿರ್ವಹಿಸುತ್ತದೆ.',
      },
      kicker: 'ಬಳಕೆದಾರರು ಪ್ರೀತಿಸುತ್ತಾರೆ',
      title: 'ನಮ್ಮ ಬಳಕೆದಾರರು ಹೇಗೆ ಹೇಳುತ್ತಾರೆ',
    },
    cta: {
      title: 'ಭಾಷಾ ಅಡೆತಡೆಗಳನ್ನು ಮುಸುಕಲು ಸಿದ್ಧರಿದ್ದೀರಾ?',
      hint: '',
      desc: '10,000+ ಬಳಕೆದಾರರೊಂದಿಗೆ ಸೇರಿ ಮತ್ತು आजನೇ ನೋಮ್ AI ನೊಂದಿಗೆ ನಿಮ್ಮ ದಾಶನಿಗಳನ್ನು ಅನುವಾದ ಮಾಡಲು ಪ್ರಾರಂಭಿಸಿ.',
      button: 'ವಿಶೇಷವಾಗಿ ಅನುವಾದ ಮಾಡಲು ಪ್ರಾರಂಭಿಸಿ',
    },
    languagePairs: {
      title: 'ಇಂಗ್ಲಿಷ್ ಪಿಡಿಎಫ್ ಏಐ ಅನುವಾದ ಜೋಡಿಗಳು',
      desc: 'ನೋಮ್ AI ಯಿಂದ ಬೆಂಬಲಿತ ಜನಪ್ರಿಯ ಅನುವಾದ ದಿಕ್ಷೆಗಳು',
    },
    footer: { privacy: 'ಗೌಪ್ಯತೆ ನಿಯಮಗಳು', about: 'ನಮ್ಮ ಬಗ್ಗೆ', contact: 'ಸಪ್ಪೋರ್ಟ್ಗೆ ಸಂಪರ್ಕಿಸಿ' },
  },
}

export default TRANSLATION
